// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminBanUserData, AdminBanUserErrors, AdminBanUserResponses, AdminDeleteUserData, AdminDeleteUserErrors, AdminDeleteUserResponses, AdminExportUsersData, AdminExportUsersErrors, AdminExportUsersResponses, AdminGetHomeData, AdminGetHomeErrors, AdminGetHomeResponses, AdminGetUserSessionsData, AdminGetUserSessionsErrors, AdminGetUserSessionsResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersResponses, AdminUnbanUserData, AdminUnbanUserErrors, AdminUnbanUserResponses, ApplicationAcknowledgeSubmissionData, ApplicationAcknowledgeSubmissionErrors, ApplicationAcknowledgeSubmissionResponses, ApplicationAddAllResidencesData, ApplicationAddAllResidencesErrors, ApplicationAddAllResidencesResponses, ApplicationAddResidenceData, ApplicationAddResidenceErrors, ApplicationAddResidenceResponses, ApplicationAnswerClarificationData, ApplicationAnswerClarificationErrors, ApplicationAnswerClarificationResponses, ApplicationCheckReadyData, ApplicationCheckReadyErrors, ApplicationCheckReadyResponses, ApplicationConfirmDocumentData, ApplicationConfirmDocumentErrors, ApplicationConfirmDocumentResponses, ApplicationConfirmSignedAnnexData, ApplicationConfirmSignedAnnexErrors, ApplicationConfirmSignedAnnexResponses, ApplicationConfirmWarningsData, ApplicationConfirmWarningsErrors, ApplicationConfirmWarningsResponses, ApplicationCorrectDirectData, ApplicationCorrectDirectErrors, ApplicationCorrectDirectResponses, ApplicationCreateDirectData, ApplicationCreateDirectDocumentUploadData, ApplicationCreateDirectDocumentUploadErrors, ApplicationCreateDirectDocumentUploadResponses, ApplicationCreateDirectErrors, ApplicationCreateDirectMessageUploadData, ApplicationCreateDirectMessageUploadErrors, ApplicationCreateDirectMessageUploadResponses, ApplicationCreateDirectResponses, ApplicationCreateDocumentUploadData, ApplicationCreateDocumentUploadErrors, ApplicationCreateDocumentUploadResponses, ApplicationCreateSignedAnnexUploadData, ApplicationCreateSignedAnnexUploadErrors, ApplicationCreateSignedAnnexUploadResponses, ApplicationDownloadAnnexAForSignatureData, ApplicationDownloadAnnexAForSignatureErrors, ApplicationDownloadAnnexAForSignatureResponses, ApplicationDownloadAnnexAPreviewData, ApplicationDownloadAnnexAPreviewErrors, ApplicationDownloadAnnexAPreviewResponses, ApplicationDownloadDocumentData, ApplicationDownloadDocumentErrors, ApplicationDownloadDocumentResponses, ApplicationDownloadReceiptData, ApplicationDownloadReceiptErrors, ApplicationDownloadReceiptResponses, ApplicationDownloadResidenceFileData, ApplicationDownloadResidenceFileErrors, ApplicationDownloadResidenceFileResponses, ApplicationDownloadSubmittedFileData, ApplicationDownloadSubmittedFileErrors, ApplicationDownloadSubmittedFileResponses, ApplicationFindSamePersonData, ApplicationFindSamePersonErrors, ApplicationFindSamePersonResponses, ApplicationGetClarificationData, ApplicationGetClarificationErrors, ApplicationGetClarificationResponses, ApplicationGetCountersForResidenceData, ApplicationGetCountersForResidenceErrors, ApplicationGetCountersForResidenceResponses, ApplicationGetDraftData, ApplicationGetDraftErrors, ApplicationGetDraftResponses, ApplicationGetForResidenceData, ApplicationGetForResidenceErrors, ApplicationGetForResidenceResponses, ApplicationGetManagerDashboardData, ApplicationGetManagerDashboardErrors, ApplicationGetManagerDashboardResponses, ApplicationGetStatusForResidenceData, ApplicationGetStatusForResidenceErrors, ApplicationGetStatusForResidenceResponses, ApplicationGetSubmissionData, ApplicationGetSubmissionErrors, ApplicationGetSubmissionResponses, ApplicationListAvailableResidencesData, ApplicationListAvailableResidencesErrors, ApplicationListAvailableResidencesResponses, ApplicationListForResidenceData, ApplicationListForResidenceErrors, ApplicationListForResidenceResponses, ApplicationListSubmissionsData, ApplicationListSubmissionsErrors, ApplicationListSubmissionsResponses, ApplicationMarkDirectPecReplySentData, ApplicationMarkDirectPecReplySentErrors, ApplicationMarkDirectPecReplySentResponses, ApplicationMarkNoticeSeenData, ApplicationMarkNoticeSeenErrors, ApplicationMarkNoticeSeenResponses, ApplicationMarkNoticesSeenData, ApplicationMarkNoticesSeenErrors, ApplicationMarkNoticesSeenResponses, ApplicationReadDirectMessageData, ApplicationReadDirectMessageErrors, ApplicationReadDirectMessageResponses, ApplicationRemoveAllResidencesData, ApplicationRemoveAllResidencesErrors, ApplicationRemoveAllResidencesResponses, ApplicationRemoveDocumentData, ApplicationRemoveDocumentErrors, ApplicationRemoveDocumentResponses, ApplicationRemoveResidenceData, ApplicationRemoveResidenceErrors, ApplicationRemoveResidenceResponses, ApplicationReportSubmissionProblemData, ApplicationReportSubmissionProblemErrors, ApplicationReportSubmissionProblemResponses, ApplicationSetDeclarationsData, ApplicationSetDeclarationsErrors, ApplicationSetDeclarationsResponses, ApplicationStartDraftData, ApplicationStartDraftErrors, ApplicationStartDraftResponses, ApplicationStartReplacementData, ApplicationStartReplacementErrors, ApplicationStartReplacementResponses, ApplicationSubmitData, ApplicationSubmitErrors, ApplicationSubmitResponses, ApplicationUpdateData, ApplicationUpdateErrors, ApplicationUpdateResponses, ApplicationWithdrawData, ApplicationWithdrawErrors, ApplicationWithdrawResponses, AssetsCreateAssetsData, AssetsCreateAssetsErrors, AssetsCreateAssetsResponses, AuthConfirmEmailChangeData, AuthConfirmEmailChangeErrors, AuthConfirmEmailChangeResponses, AuthDeleteUserData, AuthDeleteUserErrors, AuthDeleteUserResponses, AuthGetSessionData, AuthGetSessionResponses, AuthRequestEmailChangeData, AuthRequestEmailChangeErrors, AuthRequestEmailChangeResponses, AuthSendSignInOtpData, AuthSendSignInOtpErrors, AuthSendSignInOtpResponses, AuthSignInWithEmailOtpData, AuthSignInWithEmailOtpErrors, AuthSignInWithEmailOtpResponses, AuthSignOutData, AuthSignOutErrors, AuthSignOutResponses, BackofficeAuthAcceptInviteData, BackofficeAuthAcceptInviteErrors, BackofficeAuthAcceptInviteResponses, BackofficeAuthChangePasswordData, BackofficeAuthChangePasswordErrors, BackofficeAuthChangePasswordResponses, BackofficeAuthConfirmEmailChangeData, BackofficeAuthConfirmEmailChangeErrors, BackofficeAuthConfirmEmailChangeResponses, BackofficeAuthCreateAdminData, BackofficeAuthCreateAdminErrors, BackofficeAuthCreateAdminResponses, BackofficeAuthCreateAssetsData, BackofficeAuthCreateAssetsErrors, BackofficeAuthCreateAssetsResponses, BackofficeAuthDeleteAdminData, BackofficeAuthDeleteAdminErrors, BackofficeAuthDeleteAdminResponses, BackofficeAuthDisableAdminData, BackofficeAuthDisableAdminErrors, BackofficeAuthDisableAdminResponses, BackofficeAuthEnableAdminData, BackofficeAuthEnableAdminErrors, BackofficeAuthEnableAdminResponses, BackofficeAuthExportAdminsData, BackofficeAuthExportAdminsErrors, BackofficeAuthExportAdminsResponses, BackofficeAuthExportsIdData, BackofficeAuthExportsIdErrors, BackofficeAuthExportsIdResponses, BackofficeAuthGetMeData, BackofficeAuthGetMeErrors, BackofficeAuthGetMeResponses, BackofficeAuthGetSessionData, BackofficeAuthGetSessionResponses, BackofficeAuthListAdminsData, BackofficeAuthListAdminsErrors, BackofficeAuthListAdminsResponses, BackofficeAuthListSessionsData, BackofficeAuthListSessionsErrors, BackofficeAuthListSessionsResponses, BackofficeAuthRequestEmailChangeData, BackofficeAuthRequestEmailChangeErrors, BackofficeAuthRequestEmailChangeResponses, BackofficeAuthRequestPasswordResetData, BackofficeAuthRequestPasswordResetErrors, BackofficeAuthRequestPasswordResetResponses, BackofficeAuthResendInviteData, BackofficeAuthResendInviteErrors, BackofficeAuthResendInviteResponses, BackofficeAuthResetPasswordData, BackofficeAuthResetPasswordErrors, BackofficeAuthResetPasswordResponses, BackofficeAuthRevokeSessionData, BackofficeAuthRevokeSessionErrors, BackofficeAuthRevokeSessionResponses, BackofficeAuthSendChangePasswordOtpData, BackofficeAuthSendChangePasswordOtpErrors, BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSignInWithEmailData, BackofficeAuthSignInWithEmailErrors, BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignOutData, BackofficeAuthSignOutErrors, BackofficeAuthSignOutResponses, BackofficeAuthUpdateMeData, BackofficeAuthUpdateMeErrors, BackofficeAuthUpdateMeResponses, CallCloseIntakeData, CallCloseIntakeErrors, CallCloseIntakeResponses, CallConfirmDataData, CallConfirmDataErrors, CallConfirmDataResponses, CallCorrectContractInfoData, CallCorrectContractInfoErrors, CallCorrectContractInfoResponses, CallDownloadDocumentData, CallDownloadDocumentErrors, CallDownloadDocumentResponses, CallGetManagedData, CallGetManagedErrors, CallGetManagedResponses, CallGetManagerHomeData, CallGetManagerHomeErrors, CallGetManagerHomeResponses, CallListManagedData, CallListManagedErrors, CallListManagedResponses, CallMonitoringData, CallMonitoringErrors, CallMonitoringResponses, CallOpenNextYearData, CallOpenNextYearErrors, CallOpenNextYearResponses, CallPublishData, CallPublishErrors, CallPublishResponses, CallResumeApplicationsData, CallResumeApplicationsErrors, CallResumeApplicationsResponses, CallSendReminderData, CallSendReminderErrors, CallSendReminderResponses, CallSetDatesData, CallSetDatesErrors, CallSetDatesResponses, CallStopApplicationsData, CallStopApplicationsErrors, CallStopApplicationsResponses, DocsSchemaData, DsuQuotaDownloadMinistryAnswerData, DsuQuotaDownloadMinistryAnswerErrors, DsuQuotaDownloadMinistryAnswerResponses, DsuQuotaExportReportData, DsuQuotaExportReportErrors, DsuQuotaExportReportResponses, DsuQuotaGetForResidenceData, DsuQuotaGetForResidenceErrors, DsuQuotaGetForResidenceResponses, DsuQuotaRecordMinistryAnswerData, DsuQuotaRecordMinistryAnswerErrors, DsuQuotaRecordMinistryAnswerResponses, DsuQuotaUnlockOffersData, DsuQuotaUnlockOffersErrors, DsuQuotaUnlockOffersResponses, EmailListMessagesData, EmailListMessagesErrors, EmailListMessagesResponses, EmailSesEventsData, EmailSesEventsErrors, EmailSesEventsResponses, EmailTextGetData, EmailTextGetErrors, EmailTextGetResponses, EmailTextListData, EmailTextListErrors, EmailTextListResponses, EmailTextPreviewData, EmailTextPreviewErrors, EmailTextPreviewResponses, EmailTextSaveData, EmailTextSaveErrors, EmailTextSaveResponses, EventLogListData, EventLogListErrors, EventLogListResponses, GeoListInstitutionsData, GeoListInstitutionsResponses, GeoSearchMunicipalitiesData, GeoSearchMunicipalitiesErrors, GeoSearchMunicipalitiesResponses, HealthCheckBackgroundData, HealthCheckBackgroundErrors, HealthCheckBackgroundResponses, HealthCheckData, HealthCheckErrors, HealthCheckResponses, HealthCheckServicesData, OfferAcceptData, OfferAcceptErrors, OfferAcceptResponses, OfferConfirmExpiryData, OfferConfirmExpiryErrors, OfferConfirmExpiryResponses, OfferCreateReplyProofUploadData, OfferCreateReplyProofUploadErrors, OfferCreateReplyProofUploadResponses, OfferDeclineData, OfferDeclineErrors, OfferDeclineResponses, OfferGetMineData, OfferGetMineErrors, OfferGetMineResponses, OfferGetPecTextData, OfferGetPecTextErrors, OfferGetPecTextResponses, OfferLaunchData, OfferLaunchErrors, OfferLaunchResponses, OfferListExpiriesData, OfferListExpiriesErrors, OfferListExpiriesResponses, OfferListForResidenceData, OfferListForResidenceErrors, OfferListForResidenceResponses, OfferListMineData, OfferListMineErrors, OfferListMineResponses, OfferPreviewLaunchData, OfferPreviewLaunchErrors, OfferPreviewLaunchResponses, OfferReadReplyProofData, OfferReadReplyProofErrors, OfferReadReplyProofResponses, OfferRecordContactNoteData, OfferRecordContactNoteErrors, OfferRecordContactNoteResponses, OfferRecordPecSendData, OfferRecordPecSendErrors, OfferRecordPecSendResponses, OfferRecordReplyData, OfferRecordReplyErrors, OfferRecordReplyResponses, OfferResendData, OfferResendErrors, OfferResendResponses, PublicRankingGetData, PublicRankingGetErrors, PublicRankingGetResponses, PublicResidenceDownloadCallDocumentData, PublicResidenceDownloadCallDocumentErrors, PublicResidenceDownloadCallDocumentResponses, PublicResidenceGetApplicationRulesData, PublicResidenceGetApplicationRulesResponses, PublicResidenceGetData, PublicResidenceGetErrors, PublicResidenceGetResponses, PublicResidenceListData, PublicResidenceListErrors, PublicResidenceListResponses, RankingApproveData, RankingApproveErrors, RankingApproveResponses, RankingCloseReportData, RankingCloseReportErrors, RankingCloseReportResponses, RankingCreateReportData, RankingCreateReportErrors, RankingCreateReportResponses, RankingCreateReportUploadData, RankingCreateReportUploadErrors, RankingCreateReportUploadResponses, RankingDisablePageData, RankingDisablePageErrors, RankingDisablePageResponses, RankingDownloadReportFileData, RankingDownloadReportFileErrors, RankingDownloadReportFileResponses, RankingExportData, RankingExportErrors, RankingExportResponses, RankingGetControlData, RankingGetControlErrors, RankingGetControlResponses, RankingGetForStudentData, RankingGetForStudentErrors, RankingGetForStudentResponses, RankingGetProvisionalData, RankingGetProvisionalErrors, RankingGetProvisionalResponses, RankingGetRecalculationData, RankingGetRecalculationErrors, RankingGetRecalculationResponses, RankingGetReportData, RankingGetReportErrors, RankingGetReportResponses, RankingListMyReportsData, RankingListMyReportsErrors, RankingListMyReportsResponses, RankingListReportsData, RankingListReportsErrors, RankingListReportsResponses, RankingRestoreDisabilityPriorityData, RankingRestoreDisabilityPriorityErrors, RankingRestoreDisabilityPriorityResponses, RankingRevokeDisabilityPriorityData, RankingRevokeDisabilityPriorityErrors, RankingRevokeDisabilityPriorityResponses, RequirementFlagDownloadClarificationFileData, RequirementFlagDownloadClarificationFileErrors, RequirementFlagDownloadClarificationFileResponses, RequirementFlagGetForResidenceData, RequirementFlagGetForResidenceErrors, RequirementFlagGetForResidenceResponses, RequirementFlagListForResidenceData, RequirementFlagListForResidenceErrors, RequirementFlagListForResidenceResponses, RequirementFlagResolveData, RequirementFlagResolveErrors, RequirementFlagResolveResponses, RequirementFlagStartReviewData, RequirementFlagStartReviewErrors, RequirementFlagStartReviewResponses, ResidenceAddPhotosData, ResidenceAddPhotosErrors, ResidenceAddPhotosResponses, ResidenceConfirmMailboxTestCodeData, ResidenceConfirmMailboxTestCodeErrors, ResidenceConfirmMailboxTestCodeResponses, ResidenceCorrectFundedBedsData, ResidenceCorrectFundedBedsErrors, ResidenceCorrectFundedBedsResponses, ResidenceCreateData, ResidenceCreateErrors, ResidenceCreateManagerData, ResidenceCreateManagerErrors, ResidenceCreateManagerResponses, ResidenceCreatePhotoUploadData, ResidenceCreatePhotoUploadErrors, ResidenceCreatePhotoUploadResponses, ResidenceCreatePreviewLinkData, ResidenceCreatePreviewLinkErrors, ResidenceCreatePreviewLinkResponses, ResidenceCreateResponses, ResidenceGetData, ResidenceGetDsuRateData, ResidenceGetDsuRateErrors, ResidenceGetDsuRateResponses, ResidenceGetErrors, ResidenceGetMailboxTestStatusData, ResidenceGetMailboxTestStatusErrors, ResidenceGetMailboxTestStatusResponses, ResidenceGetManagedData, ResidenceGetManagedErrors, ResidenceGetManagedResponses, ResidenceGetResponses, ResidenceListData, ResidenceListErrors, ResidenceListManagersData, ResidenceListManagersErrors, ResidenceListManagersResponses, ResidenceListResponses, ResidenceRemoveManagerData, ResidenceRemoveManagerErrors, ResidenceRemoveManagerResponses, ResidenceRemovePhotoData, ResidenceRemovePhotoErrors, ResidenceRemovePhotoResponses, ResidenceReorderPhotosData, ResidenceReorderPhotosErrors, ResidenceReorderPhotosResponses, ResidenceSendMailboxTestData, ResidenceSendMailboxTestErrors, ResidenceSendMailboxTestResponses, ResidenceSetDsuRateData, ResidenceSetDsuRateErrors, ResidenceSetDsuRateResponses, ResidenceUpdateData, ResidenceUpdateErrors, ResidenceUpdateLocationData, ResidenceUpdateLocationErrors, ResidenceUpdateLocationResponses, ResidenceUpdateResponses, RoomConfirmCheckInData, RoomConfirmCheckInErrors, RoomConfirmCheckInResponses, RoomOverviewForResidenceData, RoomOverviewForResidenceErrors, RoomOverviewForResidenceResponses, RoomProposeData, RoomProposeErrors, RoomProposeResponses, RoomRecordAfterAcceptanceFactData, RoomRecordAfterAcceptanceFactErrors, RoomRecordAfterAcceptanceFactResponses, SendingAnomalyCloseData, SendingAnomalyCloseErrors, SendingAnomalyCloseResponses, SendingAnomalyGetData, SendingAnomalyGetErrors, SendingAnomalyGetRecipientData, SendingAnomalyGetRecipientErrors, SendingAnomalyGetRecipientResponses, SendingAnomalyGetResponses, SendingAnomalyListData, SendingAnomalyListErrors, SendingAnomalyListResidencesData, SendingAnomalyListResidencesErrors, SendingAnomalyListResidencesResponses, SendingAnomalyListResponses, SendingAnomalyNotifyManagerData, SendingAnomalyNotifyManagerErrors, SendingAnomalyNotifyManagerResponses, StudentFavoriteAddData, StudentFavoriteAddErrors, StudentFavoriteAddResponses, StudentFavoriteListData, StudentFavoriteListErrors, StudentFavoriteListResponses, StudentFavoriteMergeData, StudentFavoriteMergeErrors, StudentFavoriteMergeResponses, StudentFavoriteRemoveData, StudentFavoriteRemoveErrors, StudentFavoriteRemoveResponses, StudentGetProfileData, StudentGetProfileErrors, StudentGetProfileResponses, StudentReleaseTaxCodeData, StudentReleaseTaxCodeErrors, StudentReleaseTaxCodeResponses, StudentUpdateProfileData, StudentUpdateProfileErrors, StudentUpdateProfileResponses, SupportCloseRequestData, SupportCloseRequestErrors, SupportCloseRequestResponses, SupportGetStudentData, SupportGetStudentErrors, SupportGetStudentResponses, SupportListOpenRequestsData, SupportListOpenRequestsErrors, SupportListOpenRequestsResponses, SupportOpenRequestData, SupportOpenRequestErrors, SupportOpenRequestResponses, SupportResendAccessCodeData, SupportResendAccessCodeErrors, SupportResendAccessCodeResponses, SupportResendReceiptData, SupportResendReceiptErrors, SupportResendReceiptResponses, SupportSearchStudentsData, SupportSearchStudentsErrors, SupportSearchStudentsResponses, UsersGetMeData, UsersGetMeErrors, UsersGetMeResponses, VerificationCheckDocumentedValueData, VerificationCheckDocumentedValueErrors, VerificationCheckDocumentedValueResponses, VerificationCheckItemData, VerificationCheckItemErrors, VerificationCheckItemResponses, VerificationCorrectExclusionData, VerificationCorrectExclusionErrors, VerificationCorrectExclusionResponses, VerificationCreateProofUploadData, VerificationCreateProofUploadErrors, VerificationCreateProofUploadResponses, VerificationDownloadExclusionProofData, VerificationDownloadExclusionProofErrors, VerificationDownloadExclusionProofResponses, VerificationExcludeData, VerificationExcludeErrors, VerificationExcludeResponses, VerificationGetForResidenceData, VerificationGetForResidenceErrors, VerificationGetForResidenceResponses, VerificationGetNeighborsForResidenceData, VerificationGetNeighborsForResidenceErrors, VerificationGetNeighborsForResidenceResponses, VerificationListForResidenceData, VerificationListForResidenceErrors, VerificationListForResidenceResponses, VerificationMarkCompliantData, VerificationMarkCompliantErrors, VerificationMarkCompliantResponses, VerificationReadStudentNumberProofData, VerificationReadStudentNumberProofErrors, VerificationReadStudentNumberProofResponses, VerificationRecordDifferenceData, VerificationRecordDifferenceErrors, VerificationRecordDifferenceResponses, VerificationRecordStudentNumberData, VerificationRecordStudentNumberErrors, VerificationRecordStudentNumberResponses, VerificationRequestStudentNumberData, VerificationRequestStudentNumberErrors, VerificationRequestStudentNumberResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Schema
 *
 * Returns the OpenAPI JSON schema
 */
export const docsSchema = <ThrowOnError extends boolean = true>(options?: Options<DocsSchemaData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/docs/schema',
    ...options
});

/**
 * Ban User
 *
 * Ban the user in `userId`, recording an optional `reason` and an optional `expiresAt` after which the ban lifts on its own. Requires an authenticated admin with the `users.manage` ability. The banned user is signed out everywhere immediately and cannot sign in while the ban holds; active subscriptions stop renewing at period end. Returns 404 if no user matches `userId`. Use `unban-user` to lift a ban early.
 */
export const adminBanUser = <ThrowOnError extends boolean = true>(options: Options<AdminBanUserData, ThrowOnError>) => (options.client ?? client).post<AdminBanUserResponses, AdminBanUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/ban-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unban User
 *
 * Lift any ban on the user in `userId`, clearing the ban reason and expiry so the user can sign in again. Requires an authenticated admin with the `users.manage` ability. Returns 404 if no user matches `userId`; calling it on a user who is not banned succeeds and leaves them unbanned.
 */
export const adminUnbanUser = <ThrowOnError extends boolean = true>(options: Options<AdminUnbanUserData, ThrowOnError>) => (options.client ?? client).post<AdminUnbanUserResponses, AdminUnbanUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/unban-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Permanently closes the account in `userId`: it can no longer sign in and every active session is ended immediately, while the email is released so it can be reused for a brand-new sign-up. Requires an authenticated admin with the `users.manage` ability. A `reason` is required and an optional `requestReference` records the originating request (e.g. a support ticket). When the account has an email on file, the user is notified by email that their account was closed. Returns 404 if no user matches `userId`, and 409 if the account is already deleted.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = true>(options: Options<AdminDeleteUserData, ThrowOnError>) => (options.client ?? client).post<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/delete-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Users
 *
 * List users for administration, one page at a time. Requires an authenticated admin with the `users.manage` ability. Narrow results with `filters` (an explicit `ids` list for a known set or a single user, free-text `search` over name and email that also matches a full user id pasted in, `banned` state, `emailVerified` state, and a `createdAt` creation-date range with inclusive `from`/`to` bounds, each usable alone) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result. Returns students' personal data: every successful call is recorded in the event log.
 */
export const adminListUsers = <ThrowOnError extends boolean = true>(options: Options<AdminListUsersData, ThrowOnError>) => (options.client ?? client).post<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/list-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Users
 *
 * Export users using the same filters and sort supported by `list-users`. Small exports can be downloaded synchronously; large exports are queued. Returns students' personal data: the students in the file are recorded in the event log.
 */
export const adminExportUsers = <ThrowOnError extends boolean = true>(options: Options<AdminExportUsersData, ThrowOnError>) => (options.client ?? client).post<AdminExportUsersResponses, AdminExportUsersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/export-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Home
 *
 * The first page of the general admin, in boxes: the anomalies of the sendings still open, by kind, with the five open for longest (`sending.monitor`); the call of every residence with its state, closing date and valid applications, the soonest closing first (`residences.manage`); and how many requests for help are still open (`support.manage`). A box is null for an admin who lacks its ability, and nothing behind it is read; an admin with none of the three gets 403. No student appears, so nothing is recorded in the event log: the oldest requests, with who asked, come from `list-open-requests` of the support module.
 */
export const adminGetHome = <ThrowOnError extends boolean = true>(options?: Options<AdminGetHomeData, ThrowOnError>) => (options?.client ?? client).post<AdminGetHomeResponses, AdminGetHomeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/get-home',
    ...options
});

/**
 * Get User Sessions
 *
 * List the sessions of the user in `filters.userId`, newest-first, one page at a time. Includes active, expired, and revoked sessions, each with its device, IP, creation source, and lifecycle `status`. Pass `filters.status` to keep only sessions in a given lifecycle state. Read `meta` for the total count and page count. Requires an authenticated admin with the `users.manage` ability. Returns students' personal data: every successful call is recorded in the event log.
 */
export const adminGetUserSessions = <ThrowOnError extends boolean = true>(options: Options<AdminGetUserSessionsData, ThrowOnError>) => (options.client ?? client).post<AdminGetUserSessionsResponses, AdminGetUserSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/get-user-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Draft
 *
 * Opens the application the authenticated student is filling in. It only reads: a student who has not started one gets `data: null` and nothing is made, `start-draft` starts it. A student has one draft at a time. The answer holds the draft, the student profile it reads, the residences chosen and how far each of the five sections is, with the section to open first. Authenticated students only.
 */
export const applicationGetDraft = <ThrowOnError extends boolean = true>(options?: Options<ApplicationGetDraftData, ThrowOnError>) => (options?.client ?? client).post<ApplicationGetDraftResponses, ApplicationGetDraftErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-draft',
    ...options
});

/**
 * Start Draft
 *
 * Starts the application of the authenticated student, and answers it. A student has one draft at a time: starting again changes nothing and answers the draft there is. When it is made, a student who signed before starts from the last application, and the favorites with an open call are chosen in it. With `fromResidenceSlug` the residence the student came from is chosen too. Returns the draft as `get-draft` does. A student who accepted a place answers 409 `application_closed_by_acceptance`. Authenticated students only.
 */
export const applicationStartDraft = <ThrowOnError extends boolean = true>(options: Options<ApplicationStartDraftData, ThrowOnError>) => (options.client ?? client).post<ApplicationStartDraftResponses, ApplicationStartDraftErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/start-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Warnings
 *
 * The student confirms that the data behind the warnings they were shown is correct ("Confermo che i dati sono corretti"): send the `id` of each warning on the screen. Only those warnings are confirmed, and only while they are still open: a warning that opened or changed since stays to be confirmed. A confirmation covers the value and the rule it was given for: if the student later changes either (the amount, the year, the municipality, the study site), the warning opens again, unconfirmed. Warnings never block the application; without a confirmation the summary does not let the student sign. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationConfirmWarnings = <ThrowOnError extends boolean = true>(options: Options<ApplicationConfirmWarningsData, ThrowOnError>) => (options.client ?? client).post<ApplicationConfirmWarningsResponses, ApplicationConfirmWarningsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/confirm-warnings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update
 *
 * Changes what belongs to the application itself: the room preference, leaving the quota 70% out, and the need for an equipped room. Fields left out stay as they are. When `needsEquipped` is set, the chosen residences with no equipped seats are taken out and their names come back in `removedResidences`. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationUpdate = <ThrowOnError extends boolean = true>(options: Options<ApplicationUpdateData, ThrowOnError>) => (options.client ?? client).post<ApplicationUpdateResponses, ApplicationUpdateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Annex A Preview
 *
 * Downloads the preview of the Allegato A for one of the residences the student chose, as a PDF. It is addressed to the operator of that residence alone, carries the email of the account and the data filled in once, says "Anteprima, non firmato" on every page and names no other residence. The template is provisional and says so. A residence that is not in the application answers 404 `application_residence_not_chosen`; data with characters the document cannot print answers 422 `annex_a_text_unsupported`. A render that is busy answers 503 `pdf_render_unavailable`. Authenticated students only.
 */
export const applicationDownloadAnnexAPreview = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadAnnexAPreviewData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadAnnexAPreviewResponses, ApplicationDownloadAnnexAPreviewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-annex-a-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Annex A For Signature
 *
 * Downloads the Allegato A of one of the residences the student chose, to print and sign by hand: the text of the preview with no watermark, the check code of its data at the foot and the place for the date and the signature. It is addressed to the operator of that residence alone. The platform remembers which data the document was made from: a later change of the data makes the signed copy `stale` (see `annex.state` of the choices in `get-draft`), and downloading it again drops a file uploaded for the old data. A residence that is not in the application answers 404 `application_residence_not_chosen`; data with characters the document cannot print answers 422 `annex_a_text_unsupported`. A render that is busy answers 503 `pdf_render_unavailable`. Authenticated students only.
 */
export const applicationDownloadAnnexAForSignature = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadAnnexAForSignatureData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadAnnexAForSignatureResponses, ApplicationDownloadAnnexAForSignatureErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-annex-a-for-signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Signed Annex Upload
 *
 * Registers the Allegato A signed by hand for a residence and returns where to upload the file: send the raw bytes as the `upload` instruction says, then attach the returned `id` with `confirm-signed-annex`. The Allegato A to sign must have been downloaded first (`download-annex-a-for-signature`), or the answer is 409 `annex_not_downloaded`. The file goes to a private archive and is checked when attached. A file never attached is discarded; more than 20 uploads made in the last day and not attached yet answer 429 `application_document_uploads_pending`. A residence that is not in the application answers 404 `application_residence_not_chosen`. Authenticated students only.
 */
export const applicationCreateSignedAnnexUpload = <ThrowOnError extends boolean = true>(options: Options<ApplicationCreateSignedAnnexUploadData, ThrowOnError>) => (options.client ?? client).post<ApplicationCreateSignedAnnexUploadResponses, ApplicationCreateSignedAnnexUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/create-signed-annex-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Signed Annex
 *
 * Attaches an uploaded file as the Allegato A signed by hand for a residence. The content is checked against the declared type: a file that is not a PDF, JPEG or PNG as it says is removed and answers 400 `asset_content_mismatch`. A second file for the same residence replaces the first and removes its file. Without a downloaded Allegato A to sign the answer is 409 `annex_not_downloaded`. Returns the draft as `get-draft` does, where `annex.state` of the residence is now `uploaded`. Authenticated students only.
 */
export const applicationConfirmSignedAnnex = <ThrowOnError extends boolean = true>(options: Options<ApplicationConfirmSignedAnnexData, ThrowOnError>) => (options.client ?? client).post<ApplicationConfirmSignedAnnexResponses, ApplicationConfirmSignedAnnexErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/confirm-signed-annex',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Declarations
 *
 * Makes or takes back the four mandatory declarations of the Allegato A: send any of `offSite`, `noDebts`, `noConvictions` and `noIncompatibleIllness`, `true` to make it (an already made one keeps its time) and `false` to take it back. Fields left out stay as they are. Without all four the application cannot be signed. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationSetDeclarations = <ThrowOnError extends boolean = true>(options: Options<ApplicationSetDeclarationsData, ThrowOnError>) => (options.client ?? client).post<ApplicationSetDeclarationsResponses, ApplicationSetDeclarationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/set-declarations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Ready
 *
 * Says whether the application can be signed and, if not, what is missing, as codes. It is the same answer the signature asks for. An open warning is never a reason, only its confirmation; the requirements the student does not meet never block. A student with no application started answers 404 `application_draft_not_found`. Authenticated students only.
 */
export const applicationCheckReady = <ThrowOnError extends boolean = true>(options?: Options<ApplicationCheckReadyData, ThrowOnError>) => (options?.client ?? client).post<ApplicationCheckReadyResponses, ApplicationCheckReadyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/check-ready',
    ...options
});

/**
 * Mark Notices Seen
 *
 * Marks as read the notices the student was shown: send the `id` of each notice of `unreadNotices` on the screen. A notice that arrived after the screen was drawn stays unread, so the student is told about it on the next read. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationMarkNoticesSeen = <ThrowOnError extends boolean = true>(options: Options<ApplicationMarkNoticesSeenData, ThrowOnError>) => (options.client ?? client).post<ApplicationMarkNoticesSeenResponses, ApplicationMarkNoticesSeenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/mark-notices-seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Available Residences
 *
 * Lists the residences whose call is open, with the lowest monthly rate of each quota, when the call closes and whether the student already chose each in the application. Each has its `distanceKm` from the place of the student's course and `nearCourse`: the near residences, those that admit the student's university and are within `course.maxDistanceKm`, come first, nearest first, then the others in the same way, and by name when the distance is the same. With no university or place of the course in the profile `course` is null and the list is by name. When the student needs an equipped room only the residences that have one are listed. Authenticated students only.
 */
export const applicationListAvailableResidences = <ThrowOnError extends boolean = true>(options?: Options<ApplicationListAvailableResidencesData, ThrowOnError>) => (options?.client ?? client).post<ApplicationListAvailableResidencesResponses, ApplicationListAvailableResidencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/list-available-residences',
    ...options
});

/**
 * Remove All Residences
 *
 * Takes every residence out of the application. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationRemoveAllResidences = <ThrowOnError extends boolean = true>(options?: Options<ApplicationRemoveAllResidencesData, ThrowOnError>) => (options?.client ?? client).post<ApplicationRemoveAllResidencesResponses, ApplicationRemoveAllResidencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/remove-all-residences',
    ...options
});

/**
 * Add All Residences
 *
 * Chooses the residences marked `nearCourse` in `list-available-residences`: those whose call is open and admits the student's university, within the distance the call rules set from the place of the course, and when the student needs an equipped room only those that have one. A residence that is far, or has no known position, is never chosen this way, and with no university or place of the course in the profile nothing is chosen. Those already chosen stay. The name stays for compatibility. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationAddAllResidences = <ThrowOnError extends boolean = true>(options?: Options<ApplicationAddAllResidencesData, ThrowOnError>) => (options?.client ?? client).post<ApplicationAddAllResidencesResponses, ApplicationAddAllResidencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/add-all-residences',
    ...options
});

/**
 * Remove Residence
 *
 * Takes a residence out of the application; one that was not chosen changes nothing. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationRemoveResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationRemoveResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationRemoveResidenceResponses, ApplicationRemoveResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/remove-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Residence
 *
 * Chooses a residence for the application. Only a residence whose call is open can be chosen: any other answers 409 `call_not_open`; when the student needs an equipped room, one with no equipped seats answers 409 `residence_not_equipped`; a residence whose call admits only other universities than the one in the profile of the student answers 409 `institution_not_admitted`. An unknown residence answers 404 `residence_not_found`. Choosing one already chosen changes nothing. There is no order among the residences. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationAddResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationAddResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationAddResidenceResponses, ApplicationAddResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/add-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Document Upload
 *
 * Registers a document of the application and returns where to upload the file: send the raw bytes as the `upload` instruction says, then attach the returned `id` with `confirm-document`. The file goes to a private archive and is checked when attached. A file never attached is discarded; more than 20 uploads made in the last day and not attached yet answer 429 `application_document_uploads_pending`. Authenticated students only.
 */
export const applicationCreateDocumentUpload = <ThrowOnError extends boolean = true>(options: Options<ApplicationCreateDocumentUploadData, ThrowOnError>) => (options.client ?? client).post<ApplicationCreateDocumentUploadResponses, ApplicationCreateDocumentUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/create-document-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Document
 *
 * Attaches an uploaded file as the document of that kind. The content is checked against the declared type: a file that is not a PDF, JPEG or PNG as it says is removed and answers 400 `asset_content_mismatch`. A student has one document per kind: attaching another replaces the first and removes its file. The `disability` document is optional and only for a draft with `needsEquipped`: otherwise 409 `application_document_not_expected`. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationConfirmDocument = <ThrowOnError extends boolean = true>(options: Options<ApplicationConfirmDocumentData, ThrowOnError>) => (options.client ?? client).post<ApplicationConfirmDocumentResponses, ApplicationConfirmDocumentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/confirm-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Document
 *
 * Removes a document of the application and deletes its file. A document of another student answers 404. Returns the draft as `get-draft` does. Authenticated students only.
 */
export const applicationRemoveDocument = <ThrowOnError extends boolean = true>(options: Options<ApplicationRemoveDocumentData, ThrowOnError>) => (options.client ?? client).post<ApplicationRemoveDocumentResponses, ApplicationRemoveDocumentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/remove-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Document
 *
 * Returns a short-lived address to download a document of the application, with `Content-Disposition: attachment`. Only the student the document belongs to can ask: any other answers 404. Authenticated students only.
 */
export const applicationDownloadDocument = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadDocumentData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadDocumentResponses, ApplicationDownloadDocumentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit
 *
 * Sends the draft, in one act, to every residence whose call is still open. Each residence needs its Allegato A signed by hand and uploaded (`annex.state` `uploaded` in `get-draft`, made from the data the application has now): the sending refuses with 409 `annex_missing` (with `residenceIds`) or 409 `annex_stale` (with `residenceIds`, the data changed after the download). It also asks for the identity document (409 `identity_document_missing`) and for the signed Allegato A and the documents of each residence to fit one email (409 `transmission_too_large` with `residenceId`, `bytes` and `limit`). The data is frozen and the files are copied for each residence; then, in one transaction, each residence gives its protocol (a random code, `7K4MQ-9XD2B`) within that residence), the time of the sending is taken (it is the time that counts against the closing of the call) and the valid application to a residence sent again, of the same person or of the same account, is replaced. If anything fails nothing is sent. After the commit the email to each residence and the receipt email start. `residenceIds` are the residences the student saw: if a call closed since, the closed ones leave the draft and the answer is 409 `residences_changed` with the ones left (`residenceIds`) and why it differs from what the student saw: `added` (in the application now, not in the summary), `removed` (in the summary, taken out from another tab) and `closed` (in the summary, its call closed since); the student confirms again; a closed call is answered before anything else is checked. With every call closed: 409 `calls_closed`, the draft stays as it is. A draft not ready: 409 `application_not_ready`. Another sending of the student running: 409 `sign_in_progress`. More than ten calls a minute from one student: 429 `application_rate_limited` with `retryAfterSeconds`. If the files cannot be copied: 500 `sign_failed`, nothing sent. When the server is sending as many applications as it can at once, or a lock is held too long, the answer is 503 `sign_busy` with `retryAfterSeconds`: nothing was sent, ask again. A student who accepted a place answers 409 `application_closed_by_acceptance`: accepting withdrew the other applications and closes the sending. Authenticated students only.
 */
export const applicationSubmit = <ThrowOnError extends boolean = true>(options: Options<ApplicationSubmitData, ThrowOnError>) => (options.client ?? client).post<ApplicationSubmitResponses, ApplicationSubmitErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Replacement
 *
 * Starts a new application that replaces the one already sent: the student gets a draft that starts from their last signed application (preferences, documents) with the residences whose call is still open chosen again, warnings to confirm anew. The four declarations are not copied: the Allegato A of the new signature prints when each was made, so the declarations are made again. When the student signs it, the application is replaced only in the residences chosen again; the others stay as they are, and each choice says in `replacesProtocol` which protocol signing would replace. If a draft is open already it is returned. With `residenceId` ("Correggi" on the application sent to one residence) the draft replaces that one only: it is chosen again and the other residences with a valid application leave the draft, so theirs stay as they are; a residence the student chose that was never sent stays. A residence without a valid application whose call is open answers 404 `application_submission_not_found`. With every call closed the answer is 409 `calls_closed`; a student who signed nothing has nothing to replace: 404 `application_submission_not_found`; a student who accepted a place: 409 `application_closed_by_acceptance`. Authenticated students only.
 */
export const applicationStartReplacement = <ThrowOnError extends boolean = true>(options: Options<ApplicationStartReplacementData, ThrowOnError>) => (options.client ?? client).post<ApplicationStartReplacementResponses, ApplicationStartReplacementErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/start-replacement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Withdraw
 *
 * Withdraws the application of one residence, until the call of that residence closes. The application becomes `withdrawn` with the cause `student_request` and the student receives an email; the other applications stay valid. If it is the only valid application and `confirmLast` is not true the answer is 409 `last_submission` and nothing changes. After the closing the answer is 409 `call_closed`. Asked again after a withdrawal it made, it answers success and does nothing more. While a signature of the student is running, or another withdrawal of theirs, it waits for it; past a few seconds the answer is 503 `sign_busy` and nothing changes. Authenticated students only; an application of another student answers 404 `application_submission_not_found`.
 */
export const applicationWithdraw = <ThrowOnError extends boolean = true>(options: Options<ApplicationWithdrawData, ThrowOnError>) => (options.client ?? client).post<ApplicationWithdrawResponses, ApplicationWithdrawErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/withdraw',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Receipt
 *
 * Downloads the receipt of a signature as a PDF: the protocols, the time of the signature and, for each residence, its state as it stands now, with the fingerprints of the files sent. It is made at each request, so it is always up to date, and names only the residences the student applied to. Only the student the application belongs to can ask: any other answers 404. A render that is busy answers 503 `pdf_render_unavailable`. Authenticated students only.
 */
export const applicationDownloadReceipt = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadReceiptData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadReceiptResponses, ApplicationDownloadReceiptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-receipt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Submissions
 *
 * Lists the applications the authenticated student signed, one for each residence, the most recent first, including those replaced by a later one and those withdrawn. Each has its protocol, its state, the time that counts against the closing, and whether the student can still withdraw it or replace it. Authenticated students only.
 */
export const applicationListSubmissions = <ThrowOnError extends boolean = true>(options?: Options<ApplicationListSubmissionsData, ThrowOnError>) => (options?.client ?? client).post<ApplicationListSubmissionsResponses, ApplicationListSubmissionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/list-submissions',
    ...options
});

/**
 * Get Submission
 *
 * Returns one application the student signed, with what `list-submissions` says, its history (signature, replacement, withdrawal) and the files that were sent. Only the student it belongs to can ask: any other answers 404. Authenticated students only.
 */
export const applicationGetSubmission = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetSubmissionData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetSubmissionResponses, ApplicationGetSubmissionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Clarification
 *
 * Returns the clarifications the residence asked about one application of the student: the data it is about, the question, the term (24:00 Italian time of its last day), the state, and the answer once given. Each residence asks about its own application alone. Only the student it belongs to can ask: any other answers 404. Authenticated students only.
 */
export const applicationGetClarification = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetClarificationData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetClarificationResponses, ApplicationGetClarificationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-clarification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answer Clarification
 *
 * Answers a clarification the residence asked, once, before its term: the residence that asked reads it, no other. A request whose term passed answers 409 `clarification_deadline_passed`; one not waiting for an answer, or already answered, 409 `clarification_not_awaiting`; a flag of another person 404. Authenticated students only.
 */
export const applicationAnswerClarification = <ThrowOnError extends boolean = true>(options: Options<ApplicationAnswerClarificationData, ThrowOnError>) => (options.client ?? client).post<ApplicationAnswerClarificationResponses, ApplicationAnswerClarificationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/answer-clarification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Submitted File
 *
 * Returns a short-lived address to download a file that was sent with an application: the Allegato A signed by hand or a document, with `Content-Disposition: attachment`. Only the student the application belongs to can ask: any other file answers 404. Authenticated students only.
 */
export const applicationDownloadSubmittedFile = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadSubmittedFileData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadSubmittedFileResponses, ApplicationDownloadSubmittedFileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-submitted-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List For Residence
 *
 * Lists the applications sent to a residence of the account, the newest first, one page at a time: protocol, surname and name, category and quotas, origin, state and the time that counts against the closing. Narrow it with `filters` (`state`, `category`, `quota`, `origin`, `afterCall`, `search`). The figures of the whole residence are not here: `get-counters-for-residence` gives them, and they carry no student. A residence outside the account answers 404 `residence_not_found`. Returns students' personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const applicationListForResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationListForResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationListForResidenceResponses, ApplicationListForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/list-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get For Residence
 *
 * Reads one application sent to a residence of the account: the data the student signed for this residence, frozen at signing, the files that were sent with their SHA-256 and the history (signature, replacement, withdrawal). Opening it also marks seen the notice about its replacement or withdrawal. `supersededByProtocol` names the application of the residence that replaced it and `withdrawnAt` says when the student withdrew it. Nothing about the student’s applications to other residences is returned. An application of another residence answers 404 `application_submission_not_found`, a residence outside the account 404 `residence_not_found`. Returns students' personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const applicationGetForResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetForResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetForResidenceResponses, ApplicationGetForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Counters For Residence
 *
 * The figures of a residence of the account above the list of its applications: the applications in each state, and the valid ones in each category and quota, counted on the whole residence. No student appears, so nothing is recorded in the event log and the figures can be read again as often as the page needs. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationGetCountersForResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetCountersForResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetCountersForResidenceResponses, ApplicationGetCountersForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-counters-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Manager Dashboard
 *
 * The home of a facility manager: the valid applications received by the residences of the account, or by one of them, in each category and quota and day by day, against the seats of the calls; and each residence with its own figures. Only counts, no student: nothing is recorded in the event log. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationGetManagerDashboard = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetManagerDashboardData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetManagerDashboardResponses, ApplicationGetManagerDashboardErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-manager-dashboard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Status For Residence
 *
 * Whether one application sent to a residence of the account still counts: `state` (`submitted`, `superseded` or `withdrawn`), when the student withdrew it and the protocol of the application that replaced it. It is the light read to ask again while the application is open on screen: no student appears, so nothing is recorded in the event log. An application of another residence answers 404 `application_submission_not_found`, a residence outside the account 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationGetStatusForResidence = <ThrowOnError extends boolean = true>(options: Options<ApplicationGetStatusForResidenceData, ThrowOnError>) => (options.client ?? client).post<ApplicationGetStatusForResidenceResponses, ApplicationGetStatusForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/get-status-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Residence File
 *
 * Returns a short-lived address to download a file sent with an application to a residence of the account: the Allegato A signed by hand or a document, with `Content-Disposition: attachment`, or shown in the page for a PDF or an image when `view` asks. Nothing that could run is ever shown. A file of another residence answers 404 `application_submission_file_not_found`. Reads a student's personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const applicationDownloadResidenceFile = <ThrowOnError extends boolean = true>(options: Options<ApplicationDownloadResidenceFileData, ThrowOnError>) => (options.client ?? client).post<ApplicationDownloadResidenceFileResponses, ApplicationDownloadResidenceFileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/download-residence-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Acknowledge Submission
 *
 * The manager confirms the application valid after reading its data (decision D86): `reviewState` becomes `acknowledged`, the log records who and when, and the student gets an email (E19) saying the residence confirmed it is valid. No confirmation step is asked of the manager. It works also after a problem was reported; once `acknowledged` it never goes back, and a second call answers 409 `submission_already_reviewed` without sending another email (two managers at once: the first wins). An application that was replaced, withdrawn or loaded from the PEC of the residence answers 409 `submission_not_reviewable`; one of another residence 404. The application is in the ranking whatever its review, but the ranking is not approved while one in it is still `awaiting`. Requires a facility manager.
 */
export const applicationAcknowledgeSubmission = <ThrowOnError extends boolean = true>(options: Options<ApplicationAcknowledgeSubmissionData, ThrowOnError>) => (options.client ?? client).post<ApplicationAcknowledgeSubmissionResponses, ApplicationAcknowledgeSubmissionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/acknowledge-submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Notice Seen
 *
 * Marks as seen the notices about an application of the residence that was replaced by a newer one or withdrawn: the indicator in the list and the entry in the "Novità" of the first page go away. Opening the application with `get-for-residence` does the same. It is safe to repeat: a second call marks nothing. An application of another residence answers 404 `application_submission_not_found`. Requires a facility manager.
 */
export const applicationMarkNoticeSeen = <ThrowOnError extends boolean = true>(options: Options<ApplicationMarkNoticeSeenData, ThrowOnError>) => (options.client ?? client).post<ApplicationMarkNoticeSeenResponses, ApplicationMarkNoticeSeenErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/mark-notice-seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report Submission Problem
 *
 * The manager reports a problem of form in the application, with one `cause` of a closed list (`missing_signature`, `annex_mismatch`, `annex_unreadable`, `identity_document_problem`) and an optional note of up to 500 characters: `reviewState` becomes `problem`, the log records who, when and the cause (not the note, which stays on the application), and the student gets an email (E20) that says what is wrong and until when they can correct it and send again, or that the call is closed. Only for an application still `awaiting`: one already confirmed or reported answers 409 `submission_already_reviewed`; one replaced, withdrawn or loaded from the PEC of the residence 409 `submission_not_reviewable`; one of another residence 404. The application stays in the ranking. Requires a facility manager.
 */
export const applicationReportSubmissionProblem = <ThrowOnError extends boolean = true>(options: Options<ApplicationReportSubmissionProblemData, ThrowOnError>) => (options.client ?? client).post<ApplicationReportSubmissionProblemResponses, ApplicationReportSubmissionProblemErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/report-submission-problem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Direct Message Upload
 *
 * Registers the original message of an application that reached the PEC of a residence of the account, as the manager saved it, and returns where to upload it: send the raw bytes as the `upload` instruction says, then read it with `read-direct-message`. An `.eml` (`message/rfc822`, with its attachments) or a PDF up to 25 MB; anything else answers 400. The file is private and only the account that uploaded it can use it. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationCreateDirectMessageUpload = <ThrowOnError extends boolean = true>(options: Options<ApplicationCreateDirectMessageUploadData, ThrowOnError>) => (options.client ?? client).post<ApplicationCreateDirectMessageUploadResponses, ApplicationCreateDirectMessageUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/create-direct-message-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Direct Message
 *
 * Proposes when a direct application arrived and who sent it, read off the message the manager uploaded (FFD 2.4, step 2): the manager confirms or corrects them. A PEC gives the time its provider certified (`daticert.xml`) and the certified sender, kind `pec`; an ordinary email its `Date` and `From`, kind `email`; a PDF, or a message that does not read, gives nothing (`source: none`), which is not an error. A file of another account answers 403 `asset_ownership_error`, of another use 400 `asset_scope_invalid`, and one that is not what its type says 400 `asset_content_mismatch` (it is removed). A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationReadDirectMessage = <ThrowOnError extends boolean = true>(options: Options<ApplicationReadDirectMessageData, ThrowOnError>) => (options.client ?? client).post<ApplicationReadDirectMessageResponses, ApplicationReadDirectMessageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/read-direct-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Direct Document Upload
 *
 * Registers a document that came attached to an application that reached the PEC of the residence (identity document, enrolment, ISEE certificate) and returns where to upload it; then name it in `documents` of `create-direct`. A PDF or an image up to 10 MB, private to the account. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const applicationCreateDirectDocumentUpload = <ThrowOnError extends boolean = true>(options: Options<ApplicationCreateDirectDocumentUploadData, ThrowOnError>) => (options.client ?? client).post<ApplicationCreateDirectDocumentUploadResponses, ApplicationCreateDirectDocumentUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/create-direct-document-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Find Same Person
 *
 * Before loading an application that reached the PEC of the residence, lists the applications of this residence for the same tax code (or passport number, for a student with none), in any state, with protocol, origin, state and the time that counts: the one sent last before the closing is the one that counts. Never an application to another residence (decision D25). Reads students' data: every call is recorded in the event log. Requires a facility manager.
 */
export const applicationFindSamePerson = <ThrowOnError extends boolean = true>(options: Options<ApplicationFindSamePersonData, ThrowOnError>) => (options.client ?? client).post<ApplicationFindSamePersonResponses, ApplicationFindSamePersonErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/find-same-person',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Direct
 *
 * Registers an application that reached the PEC of a residence of the account (FFD 2.4): it gets the next protocol of the residence, origin `direct_pec`, and counts from the arrival of the PEC. Of two applications of the same tax code in the residence, online or direct, the one sent last counts and the other is `superseded`: a direct one that arrived before the online one is born `superseded`. The flags of the requirements not met are made with it. An email sender gets E5 with the data transcribed; for a PEC sender the answer carries the E5 text (`pecReply`) to send from the PEC of the residence. Refused while the intake is not open (409 `direct_intake_closed`), with the document of a disability and no equipped accommodation asked for (409 `application_document_not_expected`), for a PEC that arrived at or after the instant of the closing (422 `direct_arrived_after_close`), for an arrival other than the one a PEC message certifies (422 `direct_arrival_not_certified`, with `certifiedAt`), in the future or before the opening (422 `direct_arrived_out_of_window`), and for a tax code that is not valid or does not agree with the person (422 `direct_tax_code_invalid`). Requires a facility manager: the general admin does not load applications.
 */
export const applicationCreateDirect = <ThrowOnError extends boolean = true>(options: Options<ApplicationCreateDirectData, ThrowOnError>) => (options.client ?? client).post<ApplicationCreateDirectResponses, ApplicationCreateDirectErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/create-direct',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Direct Pec Reply Sent
 *
 * Records that the manager sent the E5 text (`pecReply` of `create-direct`) from the PEC of the residence to a sender with a PEC, with the author and the time, once. An application of an email sender, or one already recorded, answers 409 `direct_pec_reply_not_applicable`; one of another residence 404. Requires a facility manager.
 */
export const applicationMarkDirectPecReplySent = <ThrowOnError extends boolean = true>(options: Options<ApplicationMarkDirectPecReplySentData, ThrowOnError>) => (options.client ?? client).post<ApplicationMarkDirectPecReplySentResponses, ApplicationMarkDirectPecReplySentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/mark-direct-pec-reply-sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Direct
 *
 * Corrects the transcription of a valid direct application of a residence of the account, when the student reports a mistake: each field changed stays in the history ("Correzione di trascrizione") with the value before and after, who and when; the frozen copy is not rewritten. The requirements are judged again: a new one makes its flag, a flag whose requirement is now met is withdrawn in whatever state, an open one follows the new value, and one closed or in a clarification whose value changed is `open` again, without its outcome or its request (event `flag.reopened_by_correction`). An online, replaced or withdrawn application answers 409 `direct_correction_not_allowed`; a value equal to the current one 422 `direct_correction_unchanged`; the tax code 422 `direct_correction_tax_code` (another tax code is another application to load). A value of the wrong type answers 400. Requires a facility manager.
 */
export const applicationCorrectDirect = <ThrowOnError extends boolean = true>(options: Options<ApplicationCorrectDirectData, ThrowOnError>) => (options.client ?? client).post<ApplicationCorrectDirectResponses, ApplicationCorrectDirectErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/application/correct-direct',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Assets
 *
 * Register a new asset for the file described in `data` and return where to upload it. Authenticated users only; the authenticated user becomes the owner. The response carries an `upload` instruction describing exactly how to send the file bytes. Accepts the `user_photo` scope. Rejected when `mimeType` is not allowed for the `scope` or `sizeInBytes` exceeds its limit. The asset stays pending until you attach it to a resource, so upload the file and reference the returned `id` promptly — unused assets are eventually discarded.
 */
export const assetsCreateAssets = <ThrowOnError extends boolean = true>(options: Options<AssetsCreateAssetsData, ThrowOnError>) => (options.client ?? client).post<AssetsCreateAssetsResponses, AssetsCreateAssetsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assets/create-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Out
 *
 * Ends a session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const authSignOut = <ThrowOnError extends boolean = true>(options: Options<AuthSignOutData, ThrowOnError>) => (options.client ?? client).post<AuthSignOutResponses, AuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's current auth context: `sessionType` is `anonymous` when no valid session is present and `authenticated` otherwise, with the `session` and `user` blocks populated. Public; works with or without credentials, which makes it the endpoint to call on app start or after a page reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` to attach to later mutating requests.
 */
export const authGetSession = <ThrowOnError extends boolean = true>(options?: Options<AuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<AuthGetSessionResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/get-session',
    ...options
});

/**
 * Send Sign In Otp
 *
 * Emails a single-use sign-in code of six digits, valid 10 minutes, to the address in `email`, and returns the signed `emailOtpToken` companion the caller must echo back when submitting that code. Public; no authentication required. The response is always success and never reveals whether the address is registered — a code is always sent, even to an unknown address, so completing `sign-in-with-email-otp` creates the account when the address is new. The code is valid once and expires after a short window, after which you must request a new one. Requesting a new code for the same address invalidates any earlier code still outstanding, so only the most recently sent code works. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. Pass `rememberMe` to keep the session issued once the code is verified alive longer instead of expiring after a day. Returns 429 `otp_issuance_throttled` with `retryAfterSeconds` when another code was issued for this address less than a minute ago; 429 `otp_rate_limited` with `retryAfter` past five codes in an hour for the address or for the device (IP); 429 `otp_locked` with `lockedUntil` while the address is locked after five wrong codes.
 */
export const authSendSignInOtp = <ThrowOnError extends boolean = true>(options: Options<AuthSendSignInOtpData, ThrowOnError>) => (options.client ?? client).post<AuthSendSignInOtpResponses, AuthSendSignInOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/send-sign-in-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email Otp
 *
 * Completes passwordless sign-in by validating the `otp` together with the `emailOtpToken` returned by the request that issued the code, returning a new session. The address the code was issued for is carried inside the signed `emailOtpToken`, so the body needs neither an `email` nor any further binding check. Public; no authentication required. If the address has no account yet, one is created on the fly and signed in — so the same call serves both sign-in and sign-up. You may pass `language` to set the new account's interface language when it is created on the fly; it is ignored when the account already exists. Pairs with `send-sign-in-otp`, which delivers the code and the `emailOtpToken` you must echo back. The code is single-use and expires shortly after it is sent: a wrong or reused code answers 400 `otp_invalid` with `attemptsLeft`, a code past its 10 minutes 400 `otp_expired`. An `emailOtpToken` that is missing, expired, or shape-invalid is rejected separately without burning the code, so a legitimate retry with the right token still succeeds. The fifth wrong code in a row, on any code, locks the address for 15 minutes: 429 `otp_locked` with `lockedUntil`, here and at `send-sign-in-otp`. A successful sign-in also confirms the address if it was not yet verified. The response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie. The session's lifetime reflects the `rememberMe` choice made when the code was requested: a remembered session stays valid for an extended period, otherwise it expires after a day. There is no password and no second factor: a correct code always returns `status: success`.
 */
export const authSignInWithEmailOtp = <ThrowOnError extends boolean = true>(options: Options<AuthSignInWithEmailOtpData, ThrowOnError>) => (options.client ?? client).post<AuthSignInWithEmailOtpResponses, AuthSignInWithEmailOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/auth/sign-in-with-email-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Email Change
 *
 * Start changing the authenticated user's email to `newEmail` by sending a one-time code to that new address. If the account already has an email, a second code is also sent to the current address and both are required to confirm. Authenticated users only. The codes are single-use and expire shortly after they are sent; submit them with `newEmail` and the `emailOtpToken` returned here to `confirm-email-change` to apply the change. The response field `currentEmailVerificationRequired` is true when a code was also sent to the current address. The single `emailOtpToken` covers both codes when two were issued, and submitting the codes without it (or with a stale one from a previous call) is rejected at confirm time without consuming either code. The response is uniform whether or not `newEmail` already belongs to another account, so callers cannot learn which addresses are registered; an ownership clash is only surfaced at `confirm-email-change` once the caller has proven possession of the new mailbox. Returns 400 only when `newEmail` matches the current address. Returns 429 with `retryAfterSeconds` when a code was issued less than a minute ago for either the current or the new address.
 */
export const authRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<AuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<AuthRequestEmailChangeResponses, AuthRequestEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/auth/request-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Change
 *
 * Complete an email change for the authenticated user. Submit `newOtp` (the code sent to `newEmail`) and, when the account already has an email, also `currentOtp` (the code sent to the current address) — both must match to apply the change, switching the account to `newEmail` and marking it verified. Also submit `emailOtpToken`, the signed token returned by `request-email-change`: it binds the codes to that specific request, so a stale token from a previous send or a missing one is rejected without consuming either code. An account with no email yet confirms with `newOtp` alone and `currentOtp` is ignored. Authenticated users only; follows `request-email-change`. The codes are single-use and short-lived, so a wrong, expired, reused, missing, or mismatched code is rejected with 400 and the change is not applied. Returns 401 when `emailOtpToken` is missing, expired, or does not match the request. Returns 409 when the address was claimed by another account after the codes were requested. No new session is issued.
 */
export const authConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<AuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<AuthConfirmEmailChangeResponses, AuthConfirmEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/auth/confirm-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Permanently deletes the authenticated user's own account, resolved from the session. Authenticated users only; irreversible from the user's perspective. When the account has no verified email — no address on file, or an address not yet confirmed — deletion happens immediately and the response is `status: success`. When the account has a verified email, the first call (without `token`) emails a one-time code to that address and returns `status: requires_otp` together with an `emailOtpToken`; submit the same call again with the code as `token` and `emailOtpToken` echoed back to finalize. A missing or stale `emailOtpToken` is rejected with 401 without burning the code, so a legitimate retry with the right companion still succeeds. On `success` every session on the account is ended and the session cookie is cleared, and the email is released so it can later be used to register a brand-new account. Returns 429 with `retryAfterSeconds` when this user requested a deletion code less than a minute ago. A student who has signed an application cannot delete the account: the answer is 409 `student_has_signed_applications` and no code is sent, because signed applications are kept for the file of the residence manager.
 */
export const authDeleteUser = <ThrowOnError extends boolean = true>(options: Options<AuthDeleteUserData, ThrowOnError>) => (options.client ?? client).post<AuthDeleteUserResponses, AuthDeleteUserErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/auth/delete-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email
 *
 * Signs an existing back-office admin in with `email` and `password`. Public; no authentication required. Never creates an account — admins are invite-only. On success the response carries the new session (token, `csrfToken`, expiry), the admin, and the abilities granted to them; browsers also receive the session as a cookie. The session lasts 8 hours; a facility manager who passes `rememberMe` gets 7 days, from sign-in, not renewed by use. There is no second code: a right password signs the admin in. To avoid leaking which addresses are registered, an unknown email, a wrong password, and an admin with no password all return the same error. The fifth wrong password in a row locks the account for 15 minutes: 423 `account_locked` with `lockedUntil`, even for the right password. A disabled account answers 403 `account_disabled` once the password is verified. More than 30 attempts in 10 minutes from one network address answer 429 `too_many_attempts` with `retryAfterSeconds` (and `Retry-After`), whatever the accounts. When the server is checking as many passwords as it can, the answer is 503 `password_check_busy` with `retryAfterSeconds`: no password was checked and the wrong passwords of the account did not move, but the attempt counts toward the limit of the network address; ask again.
 */
export const backofficeAuthSignInWithEmail = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignInWithEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 *
 * Starts an admin password reset: a reset link is emailed. Public and enumeration-safe: the response is identical whether or not the address belongs to an admin, and nothing is emailed for an unknown address. Returns 429 with `retryAfterSeconds` when a reset was requested for this address less than a minute ago.
 */
export const backofficeAuthRequestPasswordReset = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRequestPasswordResetData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRequestPasswordResetResponses, BackofficeAuthRequestPasswordResetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/request-password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Completes an admin password reset with the token of the link emailed by `request-password-reset`, sets `newPassword`, and signs the admin straight in — the response carries the new session, admin, and abilities. The token is single-use. `revokeOtherSessions` (default true) ends every other active session first. The answer is always `status: success` with the session. A reset also clears the count of wrong passwords and any lockout of the account. Public. When the server is checking as many passwords as it can, the answer is 503 `password_check_busy` with `retryAfterSeconds`: the token is not spent, ask again.
 */
export const backofficeAuthResetPassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResetPasswordResponses, BackofficeAuthResetPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Rotates the authenticated admin's password to `newPassword` after authorizing the change with the code emailed by `send-change-password-otp` (`type: "otp"`). By default other sessions are ended once the change succeeds; pass `revokeOtherSessions: false` to keep them. The current session is preserved, so no new token is issued. An admin with no verified email is rejected with `backoffice_no_change_password_method_available`. When the server is checking as many passwords as it can, the answer is 503 `password_check_busy` with `retryAfterSeconds`: the code is not spent, ask again.
 */
export const backofficeAuthChangePassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthChangePasswordResponses, BackofficeAuthChangePasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Change Password Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email that authorizes a password change from inside an active session. The code is delivered to the address on file (none is taken from the request), valid for 5 minutes, single-use, and bound to the calling admin — submit it to `change-password` with `type: "otp"`. The response also carries the signed `emailOtpToken` companion the admin must echo back at `change-password` together with the typed code — without it the code is not redeemable. Requesting a new code invalidates any earlier one (and the matching `emailOtpToken` must come from the same call). Returns 400 when the admin has no verified email, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago.
 */
export const backofficeAuthSendChangePasswordOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendChangePasswordOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSendChangePasswordOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-change-password-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin
 *
 * Invites a new general admin: creates the account (no password yet) and emails an invite link to set a password via `accept-invite`. Requires the `admins.manage` ability, which only general admins have. Returns the created admin. Rejects a duplicate email with 409.
 */
export const backofficeAuthCreateAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthCreateAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthCreateAdminResponses, BackofficeAuthCreateAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invite
 *
 * Accepts an admin invite: sets the admin's `password` (and optional `name`), confirms the email, and signs them straight in — the response carries the session, admin, and abilities. Public; the invite `token` is the proof. A consumed, expired, superseded (a newer invite was sent) or unknown token is rejected, and so is any token for an account that already has a password. When the server is checking as many passwords as it can, the answer is 503 `password_check_busy` with `retryAfterSeconds`: the token is not spent, ask again.
 */
export const backofficeAuthAcceptInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthAcceptInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthAcceptInviteResponses, BackofficeAuthAcceptInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invite
 *
 * Re-sends the invite email to a pending admin (one who has not yet accepted). Requires the `admins.manage` ability. Rejects with 400 when the admin has already accepted (use the password reset flow instead) and 404 when no such admin exists.
 */
export const backofficeAuthResendInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResendInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResendInviteResponses, BackofficeAuthResendInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Admins
 *
 * List back-office admins, one page at a time. Requires the `admins.manage` ability. Narrow results with `filters` (an explicit `ids` list to fetch a known set or a single admin, free-text `search` over name and email that also matches a full admin id pasted in, an `abilities` set matched as any-of, a `disabled` state, and a derived lifecycle `status`) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result. Deleted admins are never returned.
 */
export const backofficeAuthListAdmins = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListAdminsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListAdminsResponses, BackofficeAuthListAdminsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Admins
 *
 * Export back-office admins using the same filters and sort supported by `list-admins`. Small exports can be downloaded synchronously; large exports are queued.
 */
export const backofficeAuthExportAdmins = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthExportAdminsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthExportAdminsResponses, BackofficeAuthExportAdminsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/export-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports :id
 *
 * Return the status of an async export requested by the signed-in admin. Completed exports include a short-lived download URL.
 */
export const backofficeAuthExportsId = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthExportsIdData, ThrowOnError>) => (options.client ?? client).get<BackofficeAuthExportsIdResponses, BackofficeAuthExportsIdErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/exports/{id}',
    ...options
});

/**
 * Disable Admin
 *
 * Disable an admin: blocks all sign-in and immediately ends every active session. Requires the `admins.manage` ability. You cannot disable your own account. Idempotent — disabling an already-disabled admin keeps the original disabled time. Returns the updated admin; re-enable with `enable-admin`.
 */
export const backofficeAuthDisableAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDisableAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDisableAdminResponses, BackofficeAuthDisableAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/disable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Admin
 *
 * Re-enable a disabled admin so they can sign in again. Requires the `admins.manage` ability. Idempotent — enabling an already-active admin is a no-op. Returns the updated admin. Existing sessions stay revoked; the admin signs in afresh.
 */
export const backofficeAuthEnableAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthEnableAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthEnableAdminResponses, BackofficeAuthEnableAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/enable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin
 *
 * Delete the admins in `ids` and return no content. Requires the `admins.manage` ability. Deleting an admin ends all their sessions and frees their email for re-invitation. You cannot delete your own account. All-or-nothing: if any id is unknown (or already deleted) nothing is deleted and the request is rejected.
 */
export const backofficeAuthDeleteAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDeleteAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDeleteAdminResponses, BackofficeAuthDeleteAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sessions
 *
 * List the authenticated admin's own sessions, one page at a time and ordered by most recent activity, each with its device details and lifecycle `status`. Never exposes another admin's sessions. Revoked and expired sessions stay in the list and are surfaced through `status`, while the session the request was made with is flagged by `isCurrent`. Pass `filters.status` to keep only sessions in a given lifecycle state. End any session with `revoke-session`.
 */
export const backofficeAuthListSessions = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListSessionsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListSessionsResponses, BackofficeAuthListSessionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Session
 *
 * Revoke the session identified by `sessionId`, signing out that device. Idempotent and always succeeds: revoking a session that does not exist, is not yours, or is already revoked returns success with no effect, so callers cannot probe which sessions exist. Revoking the session the call was made with immediately signs the caller out. List the available sessions with `list-sessions`.
 */
export const backofficeAuthRevokeSession = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRevokeSessionData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRevokeSessionResponses, BackofficeAuthRevokeSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/revoke-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Email Change
 *
 * Start changing the authenticated admin's email to `newEmail` by sending a one-time code to that new address. If the admin already has an email, a second code is also sent to the current address and both are required to confirm. The codes are single-use and expire shortly after they are sent; submit them with `newEmail` and the `emailOtpToken` returned here to `confirm-email-change`. `currentEmailVerificationRequired` is true when a code was also sent to the current address. The response is uniform whether or not `newEmail` already belongs to another admin, so callers cannot enumerate addresses; an ownership clash is only surfaced at `confirm-email-change`. Returns 400 only when `newEmail` matches the current address, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago for either address.
 */
export const backofficeAuthRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRequestEmailChangeResponses, BackofficeAuthRequestEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/request-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Change
 *
 * Complete an email change for the authenticated admin. Submit `newOtp` (the code sent to `newEmail`) and, when the admin already has an email, also `currentOtp` (the code sent to the current address) — both must match to switch the account to `newEmail` and mark it verified. Also submit `emailOtpToken` from `request-email-change`: it binds the codes to that request, so a stale or missing token is rejected without consuming either code. Codes are single-use and short-lived: a wrong, expired, reused, missing, or mismatched code is rejected with 400 and the change is not applied. Returns 401 when `emailOtpToken` is missing, expired, or does not match the request, and 409 when the address was claimed by another admin after the codes were requested. No new session is issued.
 */
export const backofficeAuthConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthConfirmEmailChangeResponses, BackofficeAuthConfirmEmailChangeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/confirm-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Return the authenticated admin's own profile (id, email, display name and avatar image) together with the `abilities` granted to them for client-side UI gating. Authenticated admins only; the account is resolved from the session. Use `update-me` to change the editable fields (name and avatar).
 */
export const backofficeAuthGetMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGetMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGetMeResponses, BackofficeAuthGetMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/get-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Assets
 *
 * Register a new asset for the file described in `data` and return where to upload it. Admins only; the authenticated admin becomes the owner. The response carries an `upload` instruction describing exactly how to send the file bytes. Only the `admin_avatar` scope is accepted, and the request is rejected when `mimeType` is not allowed for it or `sizeInBytes` exceeds its limit. The asset stays pending until you attach it via `update-me`, so upload the file and reference the returned `id` promptly — unused assets are eventually discarded.
 */
export const backofficeAuthCreateAssets = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthCreateAssetsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthCreateAssetsResponses, BackofficeAuthCreateAssetsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me
 *
 * Update the authenticated admin's own profile and return the updated record. Admins only; the account is resolved from the session. Only `name` and `image` can be changed — fields you omit stay as they are. Pass `image` as an asset id from the asset upload flow, or null to clear the avatar. To change your email use `request-email-change`; to change your password use `change-password`.
 */
export const backofficeAuthUpdateMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateMeResponses, BackofficeAuthUpdateMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's back-office auth context: `sessionType` is `unauthenticated` when no valid session is present and `authenticated` otherwise, with the `session`, `admin`, and `abilities` blocks populated. The `admin` block is the auth identity only (`id`, `role` and the residences); fetch the full profile (email, name, avatar) via `get-me`. Public; works with or without credentials, so it is the endpoint to call on app start or after a reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` for later mutating requests.
 */
export const backofficeAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<BackofficeAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<BackofficeAuthGetSessionResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/get-session',
    ...options
});

/**
 * Sign Out
 *
 * Ends a back-office session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const backofficeAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignOutData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignOutResponses, BackofficeAuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Managed
 *
 * Lists the calls of the residences of the facility manager account, one or more residences, every call of each with its academic year, whether it is `readOnly` (a later call is out of draft), its state, the publication conditions and the test PEC. Drafts that still miss a condition come first, then by closing time. Requires a facility manager.
 */
export const callListManaged = <ThrowOnError extends boolean = true>(options?: Options<CallListManagedData, ThrowOnError>) => (options?.client ?? client).post<CallListManagedResponses, CallListManagedErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/list-managed',
    ...options
});

/**
 * Get Managed
 *
 * Reads the call of one residence of the facility manager account: state, dates, closing time, the rules (read-only), the residence data and the session of the end day. The residence data of a draft is the residence as it is; a published call shows the copy it was published with, corrected with `correct-contract-info` and `residence/correct-funded-beds`. Without `callId` it is the current call of the residence; with it, that call, which must be of the residence (404 `call_not_found`). A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const callGetManaged = <ThrowOnError extends boolean = true>(options: Options<CallGetManagedData, ThrowOnError>) => (options.client ?? client).post<CallGetManagedResponses, CallGetManagedErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/get-managed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Manager Home
 *
 * Reads the first page of the facility manager for one residence of the account: the state and dates of the call, the counters of the applications (valid, delivered, not delivered, replaced, withdrawn) and what waits for them, the soonest deadline first: confirm the residence data and the test PEC code before publication, and check the PEC mailbox when applications could not be delivered. Counters and texts only, no student: it is not an access to personal data. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const callGetManagerHome = <ThrowOnError extends boolean = true>(options: Options<CallGetManagerHomeData, ThrowOnError>) => (options.client ?? client).post<CallGetManagerHomeResponses, CallGetManagerHomeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/get-manager-home',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Dates
 *
 * Sets when the call opens and the day it closes. Allowed in draft and, once published, until the call opens (409 `call_dates_locked` afterwards). The start must be in the future (400 `call_start_in_past`) and before the closing time of the end day (400 `call_end_before_start`). Saves `closeAt`, when the call will close on its own. Moving the dates of a published call writes its notice again, with the new dates, and keeps the new file with its SHA-256; the notice that cannot be written answers 409 `call_document_incomplete` or 422 `call_document_text_unsupported` and changes nothing, as does 503 `pdf_render_unavailable` (the PDF cannot be drawn now) and 409 `call_notice_changed` (what it prints kept changing while it was drawn): ask again. Requires the facility manager of that residence; another residence answers 404.
 */
export const callSetDates = <ThrowOnError extends boolean = true>(options: Options<CallSetDatesData, ThrowOnError>) => (options.client ?? client).post<CallSetDatesResponses, CallSetDatesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/set-dates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Data
 *
 * The facility manager confirms having checked the residence data, a condition of the publication. Any later change of the residence data voids the confirmation, which is then given again. The body carries `residenceUpdatedAt`, the version of the data the manager checked: if the data changed since (409 `call_data_changed`) the confirmation is refused and the manager reads them again. Only while the call is a draft (409 `call_already_published`). Records `call.data_confirmed`. Requires the facility manager of the residence.
 */
export const callConfirmData = <ThrowOnError extends boolean = true>(options: Options<CallConfirmDataData, ThrowOnError>) => (options.client ?? client).post<CallConfirmDataResponses, CallConfirmDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/confirm-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open Next Year
 *
 * The general admin opens the call of the next academic year of a residence: a draft for the year after its latest call, with the rules released for that year, which the facility manager prepares from the data of the residence. It is made only when every call of the residence is closed (409 `call_not_closed`) and the rules of that year are released (409 `rules_missing_for_year`). The year before stays open to applications on the seats left until its manager stops them, and the new call publishes only after that (`publish`, 409 `previous_year_accepting_applications`). Records `call.created` with the year. Requires the general admin.
 */
export const callOpenNextYear = <ThrowOnError extends boolean = true>(options: Options<CallOpenNextYearData, ThrowOnError>) => (options.client ?? client).post<CallOpenNextYearResponses, CallOpenNextYearErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/open-next-year',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Contract Info
 *
 * Corrects the contract and payment data of a call (`contractSigningDays`, `contractSigningInstructions`, `depositInstructions`, `iban`, `bankAccountHolder`): what the offers carry when they are sent, and what the call does not name. Send only the fields that change. On a draft it is a change of the residence data, like `residence/update`; once the call is published it is written on the copy of the call, which is sealed again with a new fingerprint, and the residence data, which the next call is made from, does not change. Without `callId` it is the current call; a call with a later one published answers 409 `call_read_only`. A value wrong in itself answers 400 `residence_invalid`. Records `call.contract_info_corrected` with the values before and after. Requires the general admin or a facility manager of the residence (another residence answers 404).
 */
export const callCorrectContractInfo = <ThrowOnError extends boolean = true>(options: Options<CallCorrectContractInfoData, ThrowOnError>) => (options.client ?? client).post<CallCorrectContractInfoResponses, CallCorrectContractInfoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/correct-contract-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish
 *
 * Publishes the call. Every condition of `publication` must be met; otherwise 409 `call_not_ready` lists every condition. The body carries `rulesVersion`, the version the manager saw: if a newer one is in force the call answers 409 `call_rules_changed` and nothing is published. On success the call binds the rules version in force, freezes its parameters with `paramsFingerprint`, saves `closeAt` under that rules version and the public ranking address starts answering. The notice of the call is composed once, in that same moment, and kept as a file with its SHA-256: every download is that file. Records `call.published`. A notice that cannot be written publishes nothing: 409 `call_document_incomplete` names the fields the data lack, 422 `call_document_text_unsupported` the characters it cannot print. When the PDF cannot be drawn now it answers 503 `pdf_render_unavailable`, and when what the notice prints kept changing while it was drawn 409 `call_notice_changed`: nothing is published, ask again. The call of a year publishes only after the year before has stopped taking applications on its seats left: while that one is in the phase `remaining` or `full` it answers 409 `previous_year_accepting_applications`, and the manager stops them first with `stop-applications`. Once published, the year before is only read. Requires the facility manager of the residence.
 */
export const callPublish = <ThrowOnError extends boolean = true>(options: Options<CallPublishData, ThrowOnError>) => (options.client ?? client).post<CallPublishResponses, CallPublishErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Document
 *
 * Generates the call notice ("bando") of a residence as a PDF: the text of the Ministry's scheme of Avviso, word for word, with its fields filled from the residence, its sites, the dates and the rules the call follows (decisions D61 to D63), and the rules version and fingerprint at the foot. Before publication every page says "BOZZA". A field the scheme asks and the data lack answers 409 `call_document_incomplete` with the fields: the notice is never written with a hole in it. The general admin downloads any residence; a facility manager only those of the account, and another residence answers 404. A character the Avviso font lacks is replaced only where the font has an equivalent (a no-break or narrow space becomes a space, a non-breaking hyphen a hyphen, an invisible character is dropped); any other answers 422 `call_document_text_unsupported` with the characters, instead of printing question marks. The residence save refuses such a text earlier (422 `text_not_printable`). A call published before notices were kept has its notice written at the first download: when the PDF cannot be drawn now that answers 503 `pdf_render_unavailable`, and when what it prints kept changing while it was drawn 409 `call_notice_changed`; ask again.
 */
export const callDownloadDocument = <ThrowOnError extends boolean = true>(options: Options<CallDownloadDocumentData, ThrowOnError>) => (options.client ?? client).post<CallDownloadDocumentResponses, CallDownloadDocumentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/download-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Intake
 *
 * The facility manager declares "Ho caricato tutte le domande ricevute via PEC": the intake of the applications that reached the PEC of the residence closes now, with the author, and no more can be loaded. Answers the call with its `intake`. Only once the call has closed (409 `intake_close_before_call_close`) and while the intake is open (409 `intake_already_closed`, also when its term ran out). A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const callCloseIntake = <ThrowOnError extends boolean = true>(options: Options<CallCloseIntakeData, ThrowOnError>) => (options.client ?? client).post<CallCloseIntakeResponses, CallCloseIntakeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/close-intake',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop Applications
 *
 * The facility manager stops the applications on the seats left after the call (decision D84): students can no longer choose the residence, sign or send to it, and a direct application that arrives is not loaded. Answers the call with its `applications`. Only while the call takes them (`remaining`) or has no seat free (`full`); otherwise 409 `call_applications_not_stoppable`. The log records who and when. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const callStopApplications = <ThrowOnError extends boolean = true>(options: Options<CallStopApplicationsData, ThrowOnError>) => (options.client ?? client).post<CallStopApplicationsResponses, CallStopApplicationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/stop-applications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume Applications
 *
 * The facility manager takes the applications on the seats left again after stopping them (decision D84): the call is `remaining` while a seat is free, `full` otherwise. Answers the call with its `applications`. Only once stopped; otherwise 409 `call_applications_not_stopped`. The log records who and when. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const callResumeApplications = <ThrowOnError extends boolean = true>(options: Options<CallResumeApplicationsData, ThrowOnError>) => (options.client ?? client).post<CallResumeApplicationsResponses, CallResumeApplicationsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/resume-applications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Monitoring
 *
 * Follows the calls of every residence with a published call in one academic year (the current one unless `filters.academicYear` says otherwise): the state and dates of the call, the intake of the direct applications, the flags still to close and their term, whether the residence is late, and the last reminder sent to its managers. The applications sent, the ranking, the offers, the DSU quota and the reminder follow the current call of the residence: a row of another year leaves them null (`isCurrent`). Narrow with `filters.search`, `filters.state` and `filters.academicYear`; `meta.academicYears` lists the years to choose from. Figures only, no student: it is not an access to personal data. Requires the general admin.
 */
export const callMonitoring = <ThrowOnError extends boolean = true>(options: Options<CallMonitoringData, ThrowOnError>) => (options.client ?? client).post<CallMonitoringResponses, CallMonitoringErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/monitoring',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Reminder
 *
 * Reminds the active managers of a residence of the tasks waiting on their first page, with the deadlines (email G4). With no task waiting it answers 409 `reminder_nothing_pending` and writes to nobody. It changes no outcome. Requires the general admin.
 */
export const callSendReminder = <ThrowOnError extends boolean = true>(options: Options<CallSendReminderData, ThrowOnError>) => (options.client ?? client).post<CallSendReminderResponses, CallSendReminderErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/call/send-reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ses Events
 *
 * Receives Amazon SES delivery events through an Amazon SNS subscription: delivery, bounce and complaint of each email the platform sent. Public, but every message must carry a valid SNS signature from the configured topic, otherwise it is refused with 403 and nothing changes. A subscription request is confirmed automatically. An event for a message the log does not know yet answers 503 so SNS sends it again. Not meant for clients of the platform.
 */
export const emailSesEvents = <ThrowOnError extends boolean = true>(options: Options<EmailSesEventsData, ThrowOnError>) => (options.client ?? client).post<EmailSesEventsResponses, EmailSesEventsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/email/ses-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Messages
 *
 * List the emails the platform sent, newest first, with their delivery state — queued, sent, delivered, bounced, complained or failed. The text of the email is never kept. Pass `filters.state` to keep one state, for example the bounced ones; use `cursor` from the previous response to page, and `meta.total` for the count. Returns students' addresses: every successful call is recorded in the event log. Requires the general admin.
 */
export const emailListMessages = <ThrowOnError extends boolean = true>(options: Options<EmailListMessagesData, ThrowOnError>) => (options.client ?? client).post<EmailListMessagesResponses, EmailListMessagesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/email/list-messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Lists the emails whose text the general admin edits (E1, G1…), with the text in use per language and every version. Texts with legal value (E9, P1-P4) are in the call rules and not here. Requires the general admin.
 */
export const emailTextList = <ThrowOnError extends boolean = true>(options?: Options<EmailTextListData, ThrowOnError>) => (options?.client ?? client).post<EmailTextListResponses, EmailTextListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/email-text/list',
    ...options
});

/**
 * Get
 *
 * Reads one editable email: its blocks with the variables each may use and must keep, the text in use per language and the history of versions (1 is the default text). Unknown codes and texts with legal value answer 404. Requires the general admin.
 */
export const emailTextGet = <ThrowOnError extends boolean = true>(options: Options<EmailTextGetData, ThrowOnError>) => (options.client ?? client).post<EmailTextGetResponses, EmailTextGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/email-text/get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save
 *
 * Saves a new version of an email text in one language: every block, with only the variables it may use and all those it must keep, otherwise 400 `email_text_invalid` with the issues. Emails sent from now on use it and record its version; those sent before keep theirs. Texts with legal value (E9, P1-P4) cannot be saved: 404. Records `email_text.saved`. Requires the general admin.
 */
export const emailTextSave = <ThrowOnError extends boolean = true>(options: Options<EmailTextSaveData, ThrowOnError>) => (options.client ?? client).post<EmailTextSaveResponses, EmailTextSaveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/email-text/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview
 *
 * Renders an email with sample values: the text in use, or the blocks sent (not saved). Returns the subject and the HTML. Invalid blocks answer 400 `email_text_invalid`. Requires the general admin.
 */
export const emailTextPreview = <ThrowOnError extends boolean = true>(options: Options<EmailTextPreviewData, ThrowOnError>) => (options.client ?? client).post<EmailTextPreviewResponses, EmailTextPreviewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/email-text/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * List the facts in the event log, newest first, one page at a time: who did what, on which record, when and why. Filter by residence, author, kind of fact and period with `filters`; use `cursor` from the previous response to page, and `meta.total` for the count of the current filter. Facts are never changed or removed. Requires the general admin.
 */
export const eventLogList = <ThrowOnError extends boolean = true>(options: Options<EventLogListData, ThrowOnError>) => (options.client ?? client).post<EventLogListResponses, EventLogListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/event-log/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Municipalities
 *
 * Finds Italian municipalities by the start of their name, for the pickers of a municipality in forms. Names that start with the text come first. Returns at most 20 municipalities. No authentication.
 */
export const geoSearchMunicipalities = <ThrowOnError extends boolean = true>(options: Options<GeoSearchMunicipalitiesData, ThrowOnError>) => (options.client ?? client).post<GeoSearchMunicipalitiesResponses, GeoSearchMunicipalitiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/geo/search-municipalities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Institutions
 *
 * Lists the universities of the catalogue that hold courses in Lazio, with the places where they hold them, for the pickers of an admitted university and of the student university and campus. Only active universities and sites are listed. No authentication.
 */
export const geoListInstitutions = <ThrowOnError extends boolean = true>(options?: Options<GeoListInstitutionsData, ThrowOnError>) => (options?.client ?? client).post<GeoListInstitutionsResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/geo/list-institutions',
    ...options
});

/**
 * Preview Launch
 *
 * Shows the manager what starting the offers of a residence of the account would do (FFD 2.9): whether they can start (`canLaunch`, or `block`: `ranking_not_final` until the window of review of the ranking ends, `recalculation_pending` while a calculation of the ranking waits to be worked, `already_launched` once they started), who the current version of the ranking assigns a seat to, with the quota and the channel, when the emails would leave and the offer text with an example student. The manager neither adds nor removes anybody. Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const offerPreviewLaunch = <ThrowOnError extends boolean = true>(options: Options<OfferPreviewLaunchData, ThrowOnError>) => (options.client ?? client).post<OfferPreviewLaunchResponses, OfferPreviewLaunchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/preview-launch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Launch
 *
 * Starts the offers of a residence of the account (FFD 2.9, acceptance criterion 28): one offer for each seat the current version of the final ranking assigns, to nobody else. Once only: from then on every calculation makes the offers of the seats that come free by itself. The emails leave in the sending hours of the call. Answers 409 `offer_launch_not_allowed` while the ranking is not final or once the offers started, and 409 `ranking_version_changed` when `versionNumber` is not the current version. Requires a facility manager.
 */
export const offerLaunch = <ThrowOnError extends boolean = true>(options: Options<OfferLaunchData, ThrowOnError>) => (options.client ?? client).post<OfferLaunchResponses, OfferLaunchErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/launch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List For Residence
 *
 * Lists the offers of a residence of the account (FFD 2.9): for each, the student, the category and quota, whether it was made at the launch or by a seat that came free (`scrolling`), the channel, the state, the sending, the term and the last answer, a page at a time (`page`, `limit`). Also the counts by state of the whole residence, whatever the filter and the page, the seats of the current version nobody can take (`unfilledSeats`) and the seats held beyond those of a quota (`overbooked`). Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const offerListForResidence = <ThrowOnError extends boolean = true>(options: Options<OfferListForResidenceData, ThrowOnError>) => (options.client ?? client).post<OfferListForResidenceResponses, OfferListForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/list-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Mine
 *
 * Lists the offers the student received, the latest first, with the state, the deadline as a day and, once answered, when the answer was received. Authenticated students only.
 */
export const offerListMine = <ThrowOnError extends boolean = true>(options?: Options<OfferListMineData, ThrowOnError>) => (options?.client ?? client).post<OfferListMineResponses, OfferListMineErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/list-mine',
    ...options
});

/**
 * Get Mine
 *
 * Reads one offer of the student with its text, its deadline and, while it can be answered, the other applications and offers accepting would withdraw (`willWithdraw`). The offer of another student, or one not sent yet, answers 404 `offer_not_found`. Authenticated students only.
 */
export const offerGetMine = <ThrowOnError extends boolean = true>(options: Options<OfferGetMineData, ThrowOnError>) => (options.client ?? client).post<OfferGetMineResponses, OfferGetMineErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/get-mine',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept
 *
 * Accepts an offer of the student with the button, at the instant of the call (acceptance criterion 29): it cannot be taken back. In the same transaction it withdraws the other applications and offers of the student, which `get-mine` lists in `willWithdraw`, and the student can send no new application. An offer already answered or closed answers 409 `offer_closed` with its state, one past its term 409 `offer_expired`, one not sent yet 409 `offer_not_sent`, another act of the student running 409 `offer_busy`; the offer of another student 404. Authenticated students only.
 */
export const offerAccept = <ThrowOnError extends boolean = true>(options: Options<OfferAcceptData, ThrowOnError>) => (options.client ?? client).post<OfferAcceptResponses, OfferAcceptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decline
 *
 * Declines an offer of the student with the button, at the instant of the call (acceptance criterion 29): it cannot be taken back, and the seat goes to the next student in the ranking. The other applications stay valid. An offer already answered or closed answers 409 `offer_closed` with its state, one past its term 409 `offer_expired`, one not sent yet 409 `offer_not_sent`; the offer of another student 404. Authenticated students only.
 */
export const offerDecline = <ThrowOnError extends boolean = true>(options: Options<OfferDeclineData, ThrowOnError>) => (options.client ?? client).post<OfferDeclineResponses, OfferDeclineErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Expiries
 *
 * Lists the offers of a residence of the account whose term ran out with no answer (FFD 2.11): the system proposes the lapse and only the manager confirms it, by `confirmDueAt`. Before confirming, the manager checks the PEC of the call for an answer received in time and records it with `record-reply`. Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const offerListExpiries = <ThrowOnError extends boolean = true>(options: Options<OfferListExpiriesData, ThrowOnError>) => (options.client ?? client).post<OfferListExpiriesResponses, OfferListExpiriesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/list-expiries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Expiry
 *
 * Confirms the lapse of an offer whose term ran out with no answer (FFD 2.11, acceptance criterion 30): the offer is over, the seat scrolls to the next student of the ranking and the student is told by email (E13). Only from a lapse the system proposed; otherwise 409 `offer_not_expiry_proposed` with the state. The lapse is never automatic. Requires a facility manager.
 */
export const offerConfirmExpiry = <ThrowOnError extends boolean = true>(options: Options<OfferConfirmExpiryData, ThrowOnError>) => (options.client ?? client).post<OfferConfirmExpiryResponses, OfferConfirmExpiryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/confirm-expiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Reply Proof Upload
 *
 * Registers the answer of a student that reached the PEC of the call of a residence of the account, as the manager saved it, and returns where to upload it: send the raw bytes as the `upload` instruction says, then read it with `read-reply-proof` and record it with `record-reply`. An `.eml` with its envelope, a PDF or an image, up to 25 MB; anything else answers 400. The file is private and only the account that uploaded it can use it. Requires a facility manager.
 */
export const offerCreateReplyProofUpload = <ThrowOnError extends boolean = true>(options: Options<OfferCreateReplyProofUploadData, ThrowOnError>) => (options.client ?? client).post<OfferCreateReplyProofUploadResponses, OfferCreateReplyProofUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/create-reply-proof-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Reply Proof
 *
 * Reads the answer the manager uploaded: when it arrived at the PEC of the call and who sent it, for the manager to confirm or correct before `record-reply`. The certification of a PEC gives the time the provider certified; an ordinary email its date. It only proposes. Requires a facility manager.
 */
export const offerReadReplyProof = <ThrowOnError extends boolean = true>(options: Options<OfferReadReplyProofData, ThrowOnError>) => (options.client ?? client).post<OfferReadReplyProofResponses, OfferReadReplyProofErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/read-reply-proof',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Reply
 *
 * Records the answer of a student that reached the PEC of the call by email (decision D69, acceptance criterion 29), with the message as proof and the instant it was received: the same effect as the button, and it cancels a lapse the system proposed. An acceptance withdraws the other applications and offers of the student. An answer received after the term answers 409 `offer_reply_after_deadline`; an offer already answered or withdrawn 409 `offer_closed` with its state. Requires a facility manager.
 */
export const offerRecordReply = <ThrowOnError extends boolean = true>(options: Options<OfferRecordReplyData, ThrowOnError>) => (options.client ?? client).post<OfferRecordReplyResponses, OfferRecordReplyErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/record-reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend
 *
 * Sends again an offer whose email did not reach the student (FFD 2.12, acceptance criterion 32), to the same address: it leaves in the sending hours of the call with a line saying it is sent again, and its term starts again from the new sending. Only an offer `bounced`, otherwise 409 `offer_not_bounced` with its state. If the new sending does not arrive either, the term runs anyway. Requires a facility manager.
 */
export const offerResend = <ThrowOnError extends boolean = true>(options: Options<OfferResendData, ThrowOnError>) => (options.client ?? client).post<OfferResendResponses, OfferResendErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Contact Note
 *
 * Notes a contact with the student by other means, after the email of the offer did not arrive (FFD 2.12). The note replaces the one before; the log records that it was written, never the text. It changes no term and no outcome. Requires a facility manager.
 */
export const offerRecordContactNote = <ThrowOnError extends boolean = true>(options: Options<OfferRecordContactNoteData, ThrowOnError>) => (options.client ?? client).post<OfferRecordContactNoteResponses, OfferRecordContactNoteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/record-contact-note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Pec Text
 *
 * Gives the text of an offer to send from the PEC of the residence (acceptance criterion 32): the offer text of the rules, where the student answers by replying to that PEC, the address the direct application came from and the deadline if the PEC leaves on `sentAt` (now when omitted). Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const offerGetPecText = <ThrowOnError extends boolean = true>(options: Options<OfferGetPecTextData, ThrowOnError>) => (options.client ?? client).post<OfferGetPecTextResponses, OfferGetPecTextErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/get-pec-text',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Pec Send
 *
 * Records when the manager sent an offer from the PEC of the residence, by the time of its acceptance receipt (acceptance criterion 32): the offer is sent and its term runs from then; no reminder leaves for this channel. Only an offer of the PEC channel not sent yet (409 `offer_not_to_send_by_pec`); a time in the future or before the offers started answers 400 `offer_sent_at_invalid`. Requires a facility manager.
 */
export const offerRecordPecSend = <ThrowOnError extends boolean = true>(options: Options<OfferRecordPecSendData, ThrowOnError>) => (options.client ?? client).post<OfferRecordPecSendResponses, OfferRecordPecSendErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/offer/record-pec-send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 *
 * Reads the public ranking page of a residence by its address: the slug of the residence and the day the call was published. Until the facility manager approves it answers `phase: "placeholder"` with the name and the call calendar; after, `published_review` or `final` with, for each category, the rows with position, protocol, outcome and, only for who has a seat, the quota. There is no name or personal datum, and who is not admitted does not appear. It also gives the number of valid applications, the fingerprint of the version, how the ranking is calculated and the published versions; `version` reads one of them. With the page taken down it answers `disabled`. A call in draft, an address that matches no call or a version not published answers 404, always with `X-Robots-Tag: noindex, nofollow`. No authentication.
 */
export const publicRankingGet = <ThrowOnError extends boolean = true>(options: Options<PublicRankingGetData, ThrowOnError>) => (options.client ?? client).post<PublicRankingGetResponses, PublicRankingGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/public-ranking/get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Lists the residences whose call is published, open or closed, by name, for the public showcase: cover, the lowest rate and the seats of each quota, and the state and dates of the call. The optional filters narrow by city, by room type (only residences with a seat of that kind). It also returns every city of the showcase for the city filter. A residence whose call is still a draft never appears. The answer carries no data of students or of managers and none of the bank or PEC details. No authentication.
 */
export const publicResidenceList = <ThrowOnError extends boolean = true>(options: Options<PublicResidenceListData, ThrowOnError>) => (options.client ?? client).post<PublicResidenceListResponses, PublicResidenceListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/public-residence/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 *
 * Reads the public page of a residence by its address: where it is, the photos in order, the services as codes, the rates and seats per quota and room type, and the state and dates of the call. A residence whose call is still a draft, or an unknown address, answers 404 `public_residence_not_found`. The answer carries no data of students or managers and none of the bank or PEC details. With `preview`, a token that opens the page of this residence only and for 30 minutes, the page is given in any state of the call, with `preview` true, `X-Robots-Tag: noindex, nofollow` and `Cache-Control: no-store`; a token that is invalid, expired or for another residence answers 404 even for a published call. No authentication.
 */
export const publicResidenceGet = <ThrowOnError extends boolean = true>(options: Options<PublicResidenceGetData, ThrowOnError>) => (options.client ?? client).post<PublicResidenceGetResponses, PublicResidenceGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/public-residence/get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Call Document
 *
 * Downloads the call notice ("bando") of a residence as a PDF, written from the parameters frozen at publication. A call still in draft, or an unknown address, answers 404 `public_residence_not_found`: the notice of a published call never carries the "BOZZA" watermark. It is the text of the Ministry's scheme of Avviso, the same for everyone, with the data the scheme prints: bank details and the instructions for signing and for the deposit are not in it. The same notice is served from a cache while its parameters stay the same, and an address asking more than 20 times in a minute answers 429 `public_rate_limited` with `retryAfterSeconds`. A call published before notices were kept has its notice written at the first download: when the PDF cannot be drawn now that answers 503 `pdf_render_unavailable`, and when what it prints kept changing while it was drawn 409 `call_notice_changed`; ask again. No authentication.
 */
export const publicResidenceDownloadCallDocument = <ThrowOnError extends boolean = true>(options: Options<PublicResidenceDownloadCallDocumentData, ThrowOnError>) => (options.client ?? client).post<PublicResidenceDownloadCallDocumentResponses, PublicResidenceDownloadCallDocumentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/public-residence/download-call-document',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Application Rules
 *
 * Reads the rules in force that the public page on how an application travels quotes: the time a call closes, the days a manager has to load the applications sent directly to the PEC of the residence, the days an offer stays open, the email that carries an application to the PEC of the call, on behalf of the student and with the student in copy, with the data of an application shown as `[name]`. Each comes with its `status`: anything but `fissato` is provisional. The rules change only with a platform update, and a call keeps the version it was published with: `otherVersionOpen` says when a call published or open follows another one. No authentication.
 */
export const publicResidenceGetApplicationRules = <ThrowOnError extends boolean = true>(options?: Options<PublicResidenceGetApplicationRulesData, ThrowOnError>) => (options?.client ?? client).post<PublicResidenceGetApplicationRulesResponses, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/public-residence/get-application-rules',
    ...options
});

/**
 * Get Control
 *
 * Reads the ranking of control of a residence of the account (FFD 2.7, steps 1 and 2), which is not public, one list a page at a time (`list`, `page`, `limit`): the DSU lists and the 70% list with position, surname and name, protocol, outcome, quota and where the seat comes from, the 70% list of who already holds a DSU seat, who is not admitted and why, the applications left out because the same person has a later one. With every page: the seats of each list, the rows of every list (`totals`), the versions, and the conditions to approve, each met or not, with `canApprove` true only when all are. `ranking` is null until the first calculation; the conditions say what it waits for. The names are those of the data that count now, so they follow a correction. Never data of another residence. Returns students' personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const rankingGetControl = <ThrowOnError extends boolean = true>(options: Options<RankingGetControlData, ThrowOnError>) => (options.client ?? client).post<RankingGetControlResponses, RankingGetControlErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/get-control',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recalculation
 *
 * Reads whether the ranking of a residence of the account is being recalculated: since when the oldest request waits (`pendingSince`, null when none does) and whether the calculation has already failed (`failing`). It carries no data of a student and is not recorded as an access, so a page may read it often while it waits for the calculation to end, where `get-control` is recorded at every call. Requires a facility manager.
 */
export const rankingGetRecalculation = <ThrowOnError extends boolean = true>(options: Options<RankingGetRecalculationData, ThrowOnError>) => (options.client ?? client).post<RankingGetRecalculationResponses, RankingGetRecalculationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/get-recalculation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export
 *
 * The ranking of a residence of the account as a CSV or XLSX file, to hand to the bodies that check it: while the call is open the provisional one, after the closing the version in force (none yet: a file with the headers only). One row per application: category, position, protocol, surname and name, criterion and its value, outcome and quota of the seat; then those not admitted and those excluded. Holds students' personal data: every file is recorded in the event log. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const rankingExport = <ThrowOnError extends boolean = true>(options: Options<RankingExportData, ThrowOnError>) => (options.client ?? client).post<RankingExportResponses, RankingExportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve
 *
 * Approves the ranking of a residence of the account and enables its public page (FFD 2.7, step 3). Only the facility manager approves: there is no automatic approval and the general admin does not. The call must be closed, its intake closed, its flags closed or past their term, and the calculation done; otherwise 409 `ranking_not_approvable` lists the conditions not met. `versionNumber` has to be the last version, or 409 `ranking_version_changed` gives the current one to read again. The first approval publishes the version, enables the page and opens the window to report an error (48 hours with the rules in force); a second one answers 409 `ranking_already_approved`. After the page was taken down, the same call enables it again with the same window. A version whose inputs do not replay to the saved fingerprints is not approved: 500 `ranking_version_mismatch` names what differs, and the ranking stays as it is. Requires a facility manager.
 */
export const rankingApprove = <ThrowOnError extends boolean = true>(options: Options<RankingApproveData, ThrowOnError>) => (options.client ?? client).post<RankingApproveResponses, RankingApproveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Page
 *
 * Takes the public page of the ranking of a residence of the account down for a mistake of publication (FFD 2.7, step 4), with the reason written. The page then answers that the ranking is temporarily unavailable, the student sees `phase: disabled` and cannot send reports; the ranking, its versions and its window of 48 hours are not touched, and the window keeps running. `approve` enables the page again. A page not enabled answers 409 `ranking_page_not_enabled`. Only the facility manager: the general admin gets 403. Requires a facility manager.
 */
export const rankingDisablePage = <ThrowOnError extends boolean = true>(options: Options<RankingDisablePageData, ThrowOnError>) => (options.client ?? client).post<RankingDisablePageResponses, RankingDisablePageErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/disable-page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get For Student
 *
 * Reads the ranking of the residence of one of the student's applications: the `phase` (`not_published`, `published_review`, `final`, `disabled`) and, once the ranking is published, the outcome of the application (`assigned`, `no_seat`, `not_admitted`, `excluded` when another application of the same person stands, `not_in_ranking` for a replaced or withdrawn one) with what explains it: category, position, seats, quota, the value of the criterion beside the one of the last assigned, and the admission by quota. `rows` are the public rows of the ranking by protocol, with the application asked for marked `isMine`. Before the publication, or with the page taken down, nothing but the phase. No name and nothing of another residence. Only the student it belongs to can ask: any other answers 404. Authenticated students only.
 */
export const rankingGetForStudent = <ThrowOnError extends boolean = true>(options: Options<RankingGetForStudentData, ThrowOnError>) => (options.client ?? client).post<RankingGetForStudentResponses, RankingGetForStudentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/get-for-student',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Provisional
 *
 * Reads the provisional ranking of a residence while its call is open: the engine of the ranking of control run now on the data the students declared, a flag still open ignored and marked `declaredDataUsed` ("In verifica"). It is calculated at each reading and saved nowhere: no version, no row, no request. It is not the ranking and can change until the call closes. One list a page at a time (`list`, `page`, `limit`), with the seats of each list and the rows of every list (`totals`). After the call closes, 409 `ranking_provisional_not_available`: the ranking of control stands. For the facility manager of the residence and the general admin who monitors the calls, read only; a student has no call that gives positions. Returns students' personal data: every call is recorded in the event log.
 */
export const rankingGetProvisional = <ThrowOnError extends boolean = true>(options: Options<RankingGetProvisionalData, ThrowOnError>) => (options.client ?? client).post<RankingGetProvisionalResponses, RankingGetProvisionalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/get-provisional',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Report
 *
 * Reports an error the student sees in the ranking of the residence of one of their applications. Only while the ranking is `published_review`, its page is on and the window has not ended, only for an application that stands in the published version (not one replaced, withdrawn or excluded by another application of the same person), and at most three reports per application. A file may back it: upload it with `create-report-upload` and pass its `id` as `assetId`; a file that is not a PDF, JPEG or PNG as it says answers 400 `asset_content_mismatch`. The managers of the residence are told by email (G5). The report is not an appeal: the manager of the residence reads it and answers it. Authenticated students only.
 */
export const rankingCreateReport = <ThrowOnError extends boolean = true>(options: Options<RankingCreateReportData, ThrowOnError>) => (options.client ?? client).post<RankingCreateReportResponses, RankingCreateReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/create-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Report Upload
 *
 * Registers the file that backs a report on the ranking and returns where to upload it: send the raw bytes as the `upload` instruction says, then pass the returned `id` as `assetId` to `create-report`. The file goes to a private archive and is checked when the report is created. A file never attached is discarded; five uploads made in the last day and not attached yet answer 429 `ranking_report_uploads_pending`. Authenticated students only.
 */
export const rankingCreateReportUpload = <ThrowOnError extends boolean = true>(options: Options<RankingCreateReportUploadData, ThrowOnError>) => (options.client ?? client).post<RankingCreateReportUploadResponses, RankingCreateReportUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/create-report-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Reports
 *
 * Lists the reports the student sent about one of their applications, the last first, with the state of each and the answer of the manager once it is closed. Any other student asking for the application gets 404. Authenticated students only.
 */
export const rankingListMyReports = <ThrowOnError extends boolean = true>(options: Options<RankingListMyReportsData, ThrowOnError>) => (options.client ?? client).post<RankingListMyReportsResponses, RankingListMyReportsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/list-my-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Report
 *
 * Closes a report of a residence of the account with an answer the student reads (FFD 2.8). `resolution` `no_change` closes it with nothing to correct; `corrected` needs `fact`, the flag closed or the correction of the transcription of the same application recorded after the report, which already asked for the new calculation: a fact that is not of this application or is older answers 409 `ranking_report_fact_invalid`. The first manager to close it counts: a second try answers 409 `ranking_report_already_closed`. It can be closed after the ranking is final. It changes no position, outcome or seat. Requires a facility manager.
 */
export const rankingCloseReport = <ThrowOnError extends boolean = true>(options: Options<RankingCloseReportData, ThrowOnError>) => (options.client ?? client).post<RankingCloseReportResponses, RankingCloseReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/close-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Report File
 *
 * Returns a short address of the file the student attached to a report of a residence of the account: saved, or shown in the page for a PDF or an image when `view` asks. A report with no file, or of another residence, answers 404 `ranking_report_not_found`. Reads a student's personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const rankingDownloadReportFile = <ThrowOnError extends boolean = true>(options: Options<RankingDownloadReportFileData, ThrowOnError>) => (options.client ?? client).post<RankingDownloadReportFileResponses, RankingDownloadReportFileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/download-report-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Report
 *
 * Reads one report of a residence of the account: the kind, what the student wrote, the state, the answer and the fact named when it was closed as corrected, who sent it, and where its application stands in the ranking in force (category, position, outcome). A report of another residence answers 404 `ranking_report_not_found`. Returns a student's personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const rankingGetReport = <ThrowOnError extends boolean = true>(options: Options<RankingGetReportData, ThrowOnError>) => (options.client ?? client).post<RankingGetReportResponses, RankingGetReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/get-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Reports
 *
 * Lists the reports the students sent about the ranking of a residence of the account (FFD 2.8), the last first, with the kind, the state, the version the student was reading, whether a file backs it and who sent it (protocol, surname and name from the data that count now). Filter by `state`: `open` or `closed`. Returns students' personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const rankingListReports = <ThrowOnError extends boolean = true>(options: Options<RankingListReportsData, ThrowOnError>) => (options.client ?? client).post<RankingListReportsResponses, RankingListReportsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/list-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Disability Priority
 *
 * Removes the priority of a disability from an application whose document is missing or not valid (decision D60), with the cause the rules of the call give and an optional note. The ranking gets a new version with the reason `disability_priority_revoked`, where the application competes at its normal place: when that place gives the same seat (category and quota) the offer stays, accepted or not, with its new origin; otherwise it is withdrawn without losing the quota, the seat scrolls, and the applications an acceptance of it had withdrawn are valid again. The student is told by email (E21). Only for an application that holds a seat with the priority in the last version: otherwise 409 `disability_priority_not_held`. A priority removed by mistake is given back with `restore-disability-priority`. Requires a facility manager.
 */
export const rankingRevokeDisabilityPriority = <ThrowOnError extends boolean = true>(options: Options<RankingRevokeDisabilityPriorityData, ThrowOnError>) => (options.client ?? client).post<RankingRevokeDisabilityPriorityResponses, RankingRevokeDisabilityPriorityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/revoke-disability-priority',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore Disability Priority
 *
 * Gives back a priority of a disability removed by mistake (OPSSTD-9837), with the reason: the revocation stays on record and no longer counts, and the ranking gets a new version with the reason `disability_priority_restored`. A calculation never takes back an offer already made, so the application gets a seat with the priority only if one is still free. Only for an application whose priority is removed: otherwise 409 `disability_priority_not_revoked`. Requires a facility manager.
 */
export const rankingRestoreDisabilityPriority = <ThrowOnError extends boolean = true>(options: Options<RankingRestoreDisabilityPriorityData, ThrowOnError>) => (options.client ?? client).post<RankingRestoreDisabilityPriorityResponses, RankingRestoreDisabilityPriorityErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/ranking/restore-disability-priority',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List For Residence
 *
 * Lists the flags of the valid applications of a residence of the account (FFD 2.6, step 1): protocol, surname and name, the requirement, the value declared and the threshold, the quotas it decides, the state and the end of the term to close the flags. The newest first. Narrow it with `filters` (`state`, `code`, `quota`, `open`); `counters` count the whole residence. The flags of a replaced or withdrawn application are not listed and not counted. Never a flag of another residence. Returns students' personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const requirementFlagListForResidence = <ThrowOnError extends boolean = true>(options: Options<RequirementFlagListForResidenceData, ThrowOnError>) => (options.client ?? client).post<RequirementFlagListForResidenceResponses, RequirementFlagListForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/requirement-flag/list-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get For Residence
 *
 * Reads one flag of a valid application of a residence of the account, with what judging it needs: the value declared and the threshold, the category and the quotas of the application, and its files, the one the requirement is proved with marked `relevant`. Download a file with `application/download-residence-file`. A flag of another residence, or of a replaced or withdrawn application, answers 404 `requirement_flag_not_found`. Returns students' personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const requirementFlagGetForResidence = <ThrowOnError extends boolean = true>(options: Options<RequirementFlagGetForResidenceData, ThrowOnError>) => (options.client ?? client).post<RequirementFlagGetForResidenceResponses, RequirementFlagGetForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/requirement-flag/get-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Review
 *
 * Marks a flag as being looked at by this manager when the card opens: the list shows "In esame da {nome}" for ten minutes. It holds nobody back: the first outcome recorded counts. Requires a facility manager.
 */
export const requirementFlagStartReview = <ThrowOnError extends boolean = true>(options: Options<RequirementFlagStartReviewData, ThrowOnError>) => (options.client ?? client).post<RequirementFlagStartReviewResponses, RequirementFlagStartReviewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/requirement-flag/start-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve
 *
 * Records the outcome of a flag of a residence of the account (FFD 2.6): `confirmed` (the requirement is not met: its quotas are lost in this residence and the student gets E7), `corrected` (the document shows a value that meets it) or `clarification` (the student is asked, with a term in calendar days). Every outcome needs a cause of the closed list of that outcome and kind (422 `flag_cause_invalid`); `confirmed` and `corrected` need a page of a file of the same application (422 `flag_evidence_required`). A correction equal to the value declared answers 422 `flag_correction_unchanged`, one that still fails 422 `flag_correction_still_fails`. Of two managers at once the first counts: the second gets 409 `flag_already_resolved` with the name of the first and the time. A clarification is asked only of an open flag, and a flag waiting for the student takes no outcome (409). Requires a facility manager.
 */
export const requirementFlagResolve = <ThrowOnError extends boolean = true>(options: Options<RequirementFlagResolveData, ThrowOnError>) => (options.client ?? client).post<RequirementFlagResolveResponses, RequirementFlagResolveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/requirement-flag/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Clarification File
 *
 * Returns a short address of the file the student sent with the answer to a clarification of a flag of a residence of the account: saved, or shown in the page for a PDF or an image when `view` asks. A flag with no such file, of another residence, or of an application no longer valid answers 404 `requirement_flag_not_found`. Reads a student's personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const requirementFlagDownloadClarificationFile = <ThrowOnError extends boolean = true>(options: Options<RequirementFlagDownloadClarificationFileData, ThrowOnError>) => (options.client ?? client).post<RequirementFlagDownloadClarificationFileResponses, RequirementFlagDownloadClarificationFileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/requirement-flag/download-clarification-file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create
 *
 * Creates a residence with its name and its facility manager, and its call in `draft` with the call rules in force (decision D75). Every other datum starts at 0, null or an empty list, and the manager fills it in with `update`; what is missing is listed in `issues` and stops only the publication. The page address (`slug`) is made from the name. The manager is added as `create-manager` adds one: a new address gets an account and the invite email, the address of an existing manager links that account and emails it the news. The address of a general admin answers 409 `email_in_use`, a disabled manager 409 `manager_disabled`, and then nothing is created. Requires the general admin.
 */
export const residenceCreate = <ThrowOnError extends boolean = true>(options: Options<ResidenceCreateData, ThrowOnError>) => (options.client ?? client).post<ResidenceCreateResponses, ResidenceCreateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update
 *
 * Changes the data of a residence; send only the fields that change. Every field, in every state of the calls of the residence: the data is what the next call is made from, and a call already published keeps the copy it was published with (its funded beds and contract data are corrected on the call, with `call/correct-contract-info` and `correct-funded-beds`). A value wrong in itself answers 400 `residence_invalid`; data still incomplete, or that does not add up yet, saves, is listed in `issues` and stops only the publication. A new `name` moves the page address until a call of the residence is published. A change while the residence has a draft call voids the data confirmation the facility manager gave, who must confirm the data again before publishing. Requires the general admin or a facility manager of the residence (another residence answers 404); both change every field.
 */
export const residenceUpdate = <ThrowOnError extends boolean = true>(options: Options<ResidenceUpdateData, ThrowOnError>) => (options.client ?? client).post<ResidenceUpdateResponses, ResidenceUpdateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Location
 *
 * Sets where a site of the residence is on the map: the coordinates and the Google place the admin or the facility manager picked, both coordinates together, inside Italy (latitude 35 to 48, longitude 6 to 19). A site the residence does not have answers 404. A value outside the box, or a coordinate without the other, answers 400. The position is part of the showcase, like the photos: it changes in every state of the call and does not void the data confirmation of the facility manager. The change goes to the log with the values before and after. Requires the general admin or a facility manager of the residence; another residence answers 404.
 */
export const residenceUpdateLocation = <ThrowOnError extends boolean = true>(options: Options<ResidenceUpdateLocationData, ThrowOnError>) => (options.client ?? client).post<ResidenceUpdateLocationResponses, ResidenceUpdateLocationErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/update-location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Funded Beds
 *
 * Corrects the beds admitted to funding of a call, the base of its DSU quota, in every state of the call (decision D70). On a draft it is a correction like `update`, which voids the data confirmation. Once the call is published the correction is written on its copy, which is sealed again with a new fingerprint, and the DSU quota reads the new value; the residence data, which the next call is made from, does not change. Without `callId` it is the current call; a call with a later one published answers 409 `call_read_only`. More beds than the residence has answers 400 `residence_invalid` with `funded_above_total`. The change is recorded with the value before and after; no reason is asked. Requires the general admin.
 */
export const residenceCorrectFundedBeds = <ThrowOnError extends boolean = true>(options: Options<ResidenceCorrectFundedBedsData, ThrowOnError>) => (options.client ?? client).post<ResidenceCorrectFundedBedsResponses, ResidenceCorrectFundedBedsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/correct-funded-beds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Lists the residences by name, one page at a time, each with its room counts and the state of its call. Narrow with `filters.search`. Requires the general admin.
 */
export const residenceList = <ThrowOnError extends boolean = true>(options: Options<ResidenceListData, ThrowOnError>) => (options.client ?? client).post<ResidenceListResponses, ResidenceListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 *
 * Reads residences by id, with room counts and the state of their call. The general admin reads any residence; a facility manager only its own, and another residence answers 404 as if it did not exist. Unknown ids are left out.
 */
export const residenceGet = <ThrowOnError extends boolean = true>(options: Options<ResidenceGetData, ThrowOnError>) => (options.client ?? client).post<ResidenceGetResponses, ResidenceGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Managed
 *
 * Reads one residence of the facility manager account: data, room counts, what the data still lacks and the state of its call. To change a value while the call is a draft, use `update`. A residence outside the account answers 404 `residence_not_found`. Requires a facility manager.
 */
export const residenceGetManaged = <ThrowOnError extends boolean = true>(options: Options<ResidenceGetManagedData, ThrowOnError>) => (options.client ?? client).post<ResidenceGetManagedResponses, ResidenceGetManagedErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/get-managed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Manager
 *
 * Adds a facility manager to the residence. A new address gets an account and the invite email, valid 7 days, to choose a password at `accept-invite`, and records `backoffice_user.invited`. The address of an existing manager links that account instead, keeping its name and password, emails it the news (G10) and records `backoffice_user.residence_linked`: one account can manage several residences (D17). The address of a general admin answers 409 `email_in_use`, a manager already on the residence 409 `manager_already_assigned` (unless they have not accepted the invite yet: then the invite is sent again), a disabled manager 409 `manager_disabled`. Requires the general admin.
 */
export const residenceCreateManager = <ThrowOnError extends boolean = true>(options: Options<ResidenceCreateManagerData, ThrowOnError>) => (options.client ?? client).post<ResidenceCreateManagerResponses, ResidenceCreateManagerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/create-manager',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Managers
 *
 * Lists the facility manager accounts of a residence, oldest first, with their state (`pending` until the invite is accepted, `active`, `disabled`), when they were invited and when they last signed in. Turn an account off and on with `backoffice-auth/disable-admin` and `enable-admin`, and re-send a pending invite with `resend-invite`. Requires the general admin.
 */
export const residenceListManagers = <ThrowOnError extends boolean = true>(options: Options<ResidenceListManagersData, ThrowOnError>) => (options.client ?? client).post<ResidenceListManagersResponses, ResidenceListManagersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/list-managers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Manager
 *
 * Takes a facility manager off one residence; the account keeps its other residences and stays active. An account not on the residence answers 404 `manager_not_assigned`; the last residence of an account answers 409 `manager_last_residence`: disable the account with `backoffice-auth/disable-admin` instead. Records `backoffice_user.residence_unlinked`. Requires the general admin.
 */
export const residenceRemoveManager = <ThrowOnError extends boolean = true>(options: Options<ResidenceRemoveManagerData, ThrowOnError>) => (options.client ?? client).post<ResidenceRemoveManagerResponses, ResidenceRemoveManagerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/remove-manager',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Photo Upload
 *
 * Registers a photo of a residence and returns where to upload the file: send the raw bytes as the `upload` instruction says, then attach the returned `id` with `add-photos`. A photo never attached is discarded; more than 20 uploads made in the last day and not attached yet answer 429 `residence_photo_uploads_pending`. Requires the general admin or a facility manager of the residence; another residence answers 404.
 */
export const residenceCreatePhotoUpload = <ThrowOnError extends boolean = true>(options: Options<ResidenceCreatePhotoUploadData, ThrowOnError>) => (options.client ?? client).post<ResidenceCreatePhotoUploadResponses, ResidenceCreatePhotoUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/create-photo-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Photos
 *
 * Adds uploaded photos to a residence, at the end of its photos; at most 10 in all, otherwise 409 `residence_photo_limit`. A photo the residence already has is not added twice (the call can be repeated); one that is in another residence answers 409 `residence_photo_in_use`. Photos change in any state of the call: they are the showcase, not the terms of the call. Records `residence.photos_changed`. Requires the general admin or a facility manager of the residence; another residence answers 404.
 */
export const residenceAddPhotos = <ThrowOnError extends boolean = true>(options: Options<ResidenceAddPhotosData, ThrowOnError>) => (options.client ?? client).post<ResidenceAddPhotosResponses, ResidenceAddPhotosErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/add-photos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder Photos
 *
 * Sets the order of the photos of a residence; the first becomes the cover. The list must name every photo of the residence exactly once, otherwise 400 `residence_photo_order_invalid`. Records `residence.photos_changed`. Requires the general admin or a facility manager of the residence; another residence answers 404.
 */
export const residenceReorderPhotos = <ThrowOnError extends boolean = true>(options: Options<ResidenceReorderPhotosData, ThrowOnError>) => (options.client ?? client).post<ResidenceReorderPhotosResponses, ResidenceReorderPhotosErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/reorder-photos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Photo
 *
 * Removes a photo of a residence; the following photos move up, and removing the cover makes the next photo the cover. The file is discarded later. Records `residence.photos_changed`. Requires the general admin or a facility manager of the residence; another residence answers 404.
 */
export const residenceRemovePhoto = <ThrowOnError extends boolean = true>(options: Options<ResidenceRemovePhotoData, ThrowOnError>) => (options.client ?? client).post<ResidenceRemovePhotoResponses, ResidenceRemovePhotoErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/remove-photo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Preview Link
 *
 * Gives a link to the public page of the residence as it is now, also while its call is still a draft: `/strutture/{slug}?anteprima={token}` on the student site. The token is signed by the server and works for 30 minutes and for this residence only; `public-residence/get` takes it as `preview`. Each link made is recorded as `residence.preview_link_created`. Requires the general admin or a facility manager of the residence; another residence answers 404 `residence_not_found`.
 */
export const residenceCreatePreviewLink = <ThrowOnError extends boolean = true>(options: Options<ResidenceCreatePreviewLinkData, ThrowOnError>) => (options.client ?? client).post<ResidenceCreatePreviewLinkResponses, ResidenceCreatePreviewLinkErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/create-preview-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Mailbox Test
 *
 * Sends the test email to the PEC of the call of the residence: an ordinary email from Unicasa with a new 6-digit code (the text T4 of the rules in force), which the facility manager reads in that mailbox and confirms with `confirm-mailbox-test-code`. A test still waiting for its code is replaced; before the call is published the confirmation of the previous test is voided too, once published the confirmation that published it stays and the new test only checks the mailbox (decision D23). Without an address for the call it answers 409 `residence_pec_missing`. A residence takes one test a minute and five an hour: a test asked for sooner answers 429 `mailbox_test_throttled` with `retryAfterSeconds`. Records `mailbox_test.sent`. The general admin may send it for any residence, a facility manager for their own; another residence answers 404.
 */
export const residenceSendMailboxTest = <ThrowOnError extends boolean = true>(options: Options<ResidenceSendMailboxTestData, ThrowOnError>) => (options.client ?? client).post<ResidenceSendMailboxTestResponses, ResidenceSendMailboxTestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/send-mailbox-test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Mailbox Test Status
 *
 * Reads the test email that counts for the residence: the address it went to, its delivery (`sending`, `delivered` or `refused`), whether the code is confirmed and by whom, and the wrong codes still allowed. Null when no test was sent, or the last one was voided by five wrong codes or by a change of the address. Never returns the code. The general admin reads any residence; a facility manager only their own, and another answers 404.
 */
export const residenceGetMailboxTestStatus = <ThrowOnError extends boolean = true>(options: Options<ResidenceGetMailboxTestStatusData, ThrowOnError>) => (options.client ?? client).post<ResidenceGetMailboxTestStatusResponses, ResidenceGetMailboxTestStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/get-mailbox-test-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Mailbox Test Code
 *
 * The facility manager confirms the code of the test email, read in the mailbox of the PEC of the call. A wrong code answers 400 `mailbox_test_code_invalid` with `attemptsLeft`; at the fifth the test is void and a new one is sent (the next call answers 404 `mailbox_test_not_found`). If the mailbox refused the email, 409 `mailbox_test_refused`: check that it accepts ordinary mail and send the test again. Confirming again is harmless. Records `mailbox_test.confirmed` or `mailbox_test.failed_attempt`. Only for the facility manager of the residence; another residence answers 404.
 */
export const residenceConfirmMailboxTestCode = <ThrowOnError extends boolean = true>(options: Options<ResidenceConfirmMailboxTestCodeData, ThrowOnError>) => (options.client ?? client).post<ResidenceConfirmMailboxTestCodeResponses, ResidenceConfirmMailboxTestCodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/confirm-mailbox-test-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dsu Rate
 *
 * The DSU rate the quota 30% of every residence charges, single and double, as the general admin last set it; null before the first. Requires the general admin.
 */
export const residenceGetDsuRate = <ThrowOnError extends boolean = true>(options?: Options<ResidenceGetDsuRateData, ThrowOnError>) => (options?.client ?? client).post<ResidenceGetDsuRateResponses, ResidenceGetDsuRateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/get-dsu-rate',
    ...options
});

/**
 * Set Dsu Rate
 *
 * Sets the DSU rate the quota 30% of every residence charges. Every residence whose call is a draft takes it at once, and loses the data confirmation of its manager when the rate changes for it; a published call keeps the rate it went out with. Recorded with the rate before and after. Requires the general admin.
 */
export const residenceSetDsuRate = <ThrowOnError extends boolean = true>(options: Options<ResidenceSetDsuRateData, ThrowOnError>) => (options.client ?? client).post<ResidenceSetDsuRateResponses, ResidenceSetDsuRateErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/residence/set-dsu-rate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Residences
 *
 * The sendings of every residence: the anomalies still open by kind. `withoutResidence` counts the open anomalies of no residence. No student appears. Requires a general admin.
 */
export const sendingAnomalyListResidences = <ThrowOnError extends boolean = true>(options?: Options<SendingAnomalyListResidencesData, ThrowOnError>) => (options?.client ?? client).post<SendingAnomalyListResidencesResponses, SendingAnomalyListResidencesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/list-residences',
    ...options
});

/**
 * List
 *
 * Lists the anomalies of the sendings, the open ones first and the newest first, one page at a time. Narrow it with `filters` (`kind`, `residenceId`, `state`). Each item says which commands are available. No student appears, so nothing is recorded in the event log: the refused address of an `email_bounced` comes from `get-recipient`. Requires a general admin.
 */
export const sendingAnomalyList = <ThrowOnError extends boolean = true>(options: Options<SendingAnomalyListData, ThrowOnError>) => (options.client ?? client).post<SendingAnomalyListResponses, SendingAnomalyListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 *
 * Reads one anomaly: its reason and the application it is about with the time that counts against the closing. No student appears, so nothing is recorded in the event log: the refused address of an `email_bounced` comes from `get-recipient`. Requires a general admin.
 */
export const sendingAnomalyGet = <ThrowOnError extends boolean = true>(options: Options<SendingAnomalyGetData, ThrowOnError>) => (options.client ?? client).post<SendingAnomalyGetResponses, SendingAnomalyGetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/get',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recipient
 *
 * The address the email of an `email_bounced` anomaly was refused at, and the student it was for. Both are null for another kind and for an email to a back-office user, whose address is staff data. The address of a student is personal data: every call that returns one is recorded in the event log. Requires a general admin.
 */
export const sendingAnomalyGetRecipient = <ThrowOnError extends boolean = true>(options: Options<SendingAnomalyGetRecipientData, ThrowOnError>) => (options.client ?? client).post<SendingAnomalyGetRecipientResponses, SendingAnomalyGetRecipientErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/get-recipient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notify Manager
 *
 * Sends the facility managers of the residence the email about an application that did not get there again ("Avvisa il gestore", G3). A residence with no active facility manager answers 409 `sending_anomaly_no_managers` and nothing is recorded. It is in the event log with the admin. Requires a general admin.
 */
export const sendingAnomalyNotifyManager = <ThrowOnError extends boolean = true>(options: Options<SendingAnomalyNotifyManagerData, ThrowOnError>) => (options.client ?? client).post<SendingAnomalyNotifyManagerResponses, SendingAnomalyNotifyManagerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/notify-manager',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close
 *
 * Closes an open anomaly with a note. It changes nothing else: the application keeps its state and the time that counts. The note and the admin are in the event log. Requires a general admin.
 */
export const sendingAnomalyClose = <ThrowOnError extends boolean = true>(options: Options<SendingAnomalyCloseData, ThrowOnError>) => (options.client ?? client).post<SendingAnomalyCloseResponses, SendingAnomalyCloseErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/sending-anomaly/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Profile
 *
 * Reads the authenticated student's profile, the email of the account and how complete each of the five sections is. A student who has not filled anything in yet gets an empty profile. Authenticated students only. Reading your own profile is not logged as an access to personal data.
 */
export const studentGetProfile = <ThrowOnError extends boolean = true>(options?: Options<StudentGetProfileData, ThrowOnError>) => (options?.client ?? client).post<StudentGetProfileResponses, StudentGetProfileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student/get-profile',
    ...options
});

/**
 * Update Profile
 *
 * Changes the authenticated student's profile: send any of the fields, a section at a time. Fields left out stay as they are and `null` empties one. Everything sent is checked together: if any field is not valid the answer is 400 `student_profile_invalid`, with every problem per field, and nothing is saved. The tax code must agree with surname, name and date of birth and belongs to one profile only: one that cannot be used answers 400 `student_profile_invalid` with `tax_code_unavailable` on `taxCode`, without saying why, and after five such tries in an hour any tax code sent answers 429 `tax_code_attempts_limited` with `retryAfterSeconds`. Authenticated students only.
 */
export const studentUpdateProfile = <ThrowOnError extends boolean = true>(options: Options<StudentUpdateProfileData, ThrowOnError>) => (options.client ?? client).post<StudentUpdateProfileResponses, StudentUpdateProfileErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student/update-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Release Tax Code
 *
 * Frees a tax code that a profile holds and its owner cannot save: a student who saved another person's tax code first holds it, and the real owner is told only that it cannot be used. The general admin frees it after proving the identity of the person who asks. The profile that held it keeps its other data and goes back to incomplete (its personal section asks for a tax code again); the log records `student.tax_code_released` with who did it and whether a `reason` was given, never the tax code or the text of the reason. A tax code no profile holds answers 404 `student_tax_code_not_found`; a profile that signed an application answers 409 `student_has_signed_applications` and is not touched. Requires the `users.manage` ability.
 */
export const studentReleaseTaxCode = <ThrowOnError extends boolean = true>(options: Options<StudentReleaseTaxCodeData, ThrowOnError>) => (options.client ?? client).post<StudentReleaseTaxCodeResponses, StudentReleaseTaxCodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student/release-tax-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Lists the residences the authenticated student marked as favorites, the latest first, with the state of their call. Authenticated students only.
 */
export const studentFavoriteList = <ThrowOnError extends boolean = true>(options?: Options<StudentFavoriteListData, ThrowOnError>) => (options?.client ?? client).post<StudentFavoriteListResponses, StudentFavoriteListErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student-favorite/list',
    ...options
});

/**
 * Add
 *
 * Marks a residence as a favorite of the authenticated student, by its page address. Marking it again changes nothing. A residence with no published call, or an unknown address, answers 404 `favorite_residence_not_found`. Returns the list as `list` does. Authenticated students only.
 */
export const studentFavoriteAdd = <ThrowOnError extends boolean = true>(options: Options<StudentFavoriteAddData, ThrowOnError>) => (options.client ?? client).post<StudentFavoriteAddResponses, StudentFavoriteAddErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student-favorite/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove
 *
 * Unmarks a residence, by its page address. One that was not marked, or does not exist, changes nothing and is no error. Returns the list as `list` does. Authenticated students only.
 */
export const studentFavoriteRemove = <ThrowOnError extends boolean = true>(options: Options<StudentFavoriteRemoveData, ThrowOnError>) => (options.client ?? client).post<StudentFavoriteRemoveResponses, StudentFavoriteRemoveErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student-favorite/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merge
 *
 * Adds to the favorites of the authenticated student the residences a visitor marked in the browser before signing in. Those that exist and have a published call are added; the others are ignored without an error, and one already marked is not marked twice. Call it once after sign-in, then empty the browser list. Returns the list as `list` does. Authenticated students only.
 */
export const studentFavoriteMerge = <ThrowOnError extends boolean = true>(options: Options<StudentFavoriteMergeData, ThrowOnError>) => (options.client ?? client).post<StudentFavoriteMergeResponses, StudentFavoriteMergeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/student-favorite/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Students
 *
 * Finds the students a search text points to: a protocol code (five characters, a dash, five characters) is read as the protocol of an application in any residence, sixteen letters and digits as a tax code, anything else as part of an email address. More than 20 students: `tooMany` is true and no list is given, narrow the search. Returns students' personal data: every successful call is recorded in the event log with the students found. Requires a general admin.
 */
export const supportSearchStudents = <ThrowOnError extends boolean = true>(options: Options<SupportSearchStudentsData, ThrowOnError>) => (options.client ?? client).post<SupportSearchStudentsResponses, SupportSearchStudentsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/search-students',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Student
 *
 * The card of support of a student: the account, the applications of the residences with their states, delivery states, times and PEC receipts, the latest emails with their outcome and the requests for help. It holds no uploaded document, no frozen data and no signed file. Returns a student's personal data: every successful call is recorded in the event log. Requires a general admin.
 */
export const supportGetStudent = <ThrowOnError extends boolean = true>(options: Options<SupportGetStudentData, ThrowOnError>) => (options.client ?? client).post<SupportGetStudentResponses, SupportGetStudentErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/get-student',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Access Code
 *
 * Sends the student a new sign-in code (email E1) at the address of the account, with the limits of the sign-in page: 429 `otp_issuance_throttled` inside the minute, 429 `otp_rate_limited` past five codes in an hour, 429 `otp_locked` while the address is locked. An account that is banned or closed gets nothing: 409 `support_student_unavailable`. It is in the event log with the admin. Requires a general admin.
 */
export const supportResendAccessCode = <ThrowOnError extends boolean = true>(options: Options<SupportResendAccessCodeData, ThrowOnError>) => (options.client ?? client).post<SupportResendAccessCodeResponses, SupportResendAccessCodeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/resend-access-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Receipt
 *
 * Sends the student the receipt of a signature again (email E3) with the up to date times of acceptance and delivery, to the address the account has now (the receipt still shows the address of the application). An account that is banned or closed gets nothing: 409 `support_student_unavailable`. It is in the event log with the admin. Requires a general admin.
 */
export const supportResendReceipt = <ThrowOnError extends boolean = true>(options: Options<SupportResendReceiptData, ThrowOnError>) => (options.client ?? client).post<SupportResendReceiptResponses, SupportResendReceiptErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/resend-receipt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open Request
 *
 * Writes down a request for help that reached the support address, against the student. It stays open until `close-request` and is listed in `list-open-requests`. It is in the event log with the admin. Requires a general admin.
 */
export const supportOpenRequest = <ThrowOnError extends boolean = true>(options: Options<SupportOpenRequestData, ThrowOnError>) => (options.client ?? client).post<SupportOpenRequestResponses, SupportOpenRequestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/open-request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Request
 *
 * Closes a request for help recording the answer that was given. The answer is required. It is in the event log with the admin. Requires a general admin.
 */
export const supportCloseRequest = <ThrowOnError extends boolean = true>(options: Options<SupportCloseRequestData, ThrowOnError>) => (options.client ?? client).post<SupportCloseRequestResponses, SupportCloseRequestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/close-request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Open Requests
 *
 * The requests for help still open, the oldest first, one page at a time, each with the student it is about: for the first page of the console. Read `meta.total` for how many are open in all. Returns students' personal data: every successful call that returns a request is recorded in the event log. Requires a general admin.
 */
export const supportListOpenRequests = <ThrowOnError extends boolean = true>(options: Options<SupportListOpenRequestsData, ThrowOnError>) => (options.client ?? client).post<SupportListOpenRequestsResponses, SupportListOpenRequestsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/support/list-open-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Return the authenticated user's own profile: display name, verified email, avatar image, gender, and `emailStatus`, which tells a missing address apart from an unconfirmed one. Authenticated users only; the account is always resolved from the session, so no payload is required.
 */
export const usersGetMe = <ThrowOnError extends boolean = true>(options?: Options<UsersGetMeData, ThrowOnError>) => (options?.client ?? client).post<UsersGetMeResponses, UsersGetMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/users/get-me',
    ...options
});

/**
 * List For Residence
 *
 * Lists the verifications of the documents of the assignees who accepted an offer of a residence of the account (FFD 2.13): protocol, surname and name, quota and category of the offer, the state, when the offer was accepted and what is still to check. The pending ones first, then by acceptance. A verification is opened by the acceptance itself. They come a page at a time (`page`, `limit`), with `filters.state` and `filters.search`; `counters` count the whole residence whatever the filters and the page. Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const verificationListForResidence = <ThrowOnError extends boolean = true>(options: Options<VerificationListForResidenceData, ThrowOnError>) => (options.client ?? client).post<VerificationListForResidenceResponses, VerificationListForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/list-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get For Residence
 *
 * Reads one verification of a residence of the account with what the manager compares: what the student declared, with the corrections recorded since, the items of the checklist this application is checked on and how each was checked, the student number of a student who only pre-enrolled, and the files of the application, each with the item it proves. Download a file with `application/download-residence-file`, which records the reading. `seatHeld` says whether the offer is still accepted. A verification of another residence answers 404 `verification_not_found`. Returns students’ personal data: every call is recorded in the event log. Requires a facility manager.
 */
export const verificationGetForResidence = <ThrowOnError extends boolean = true>(options: Options<VerificationGetForResidenceData, ThrowOnError>) => (options.client ?? client).post<VerificationGetForResidenceResponses, VerificationGetForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/get-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Neighbors For Residence
 *
 * Names the verifications before and after one of a residence of the account, in the order of `list-for-residence` and with the `filters` of the list the manager came from: what the arrows of the card open. The verification keeps its place even when it no longer matches the filters, as one just settled while the list shows the pending ones. Null at either end, both null for a seat lost, which the list leaves out. Only ids: nothing is recorded in the event log. Requires a facility manager.
 */
export const verificationGetNeighborsForResidence = <ThrowOnError extends boolean = true>(options: Options<VerificationGetNeighborsForResidenceData, ThrowOnError>) => (options.client ?? client).post<VerificationGetNeighborsForResidenceResponses, VerificationGetNeighborsForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/get-neighbors-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Item
 *
 * Marks an item of the checklist of a pending verification as matching what the student declared, or takes the mark back with `matches` false, and returns the verification. An item this application is not checked on (the credits outside the later years) answers 422 `verification_item_not_applicable`; a verification with an outcome answers 409 `verification_not_pending`. A verification whose seat was lost (the offer no longer accepted) answers 409 `offer_not_accepted`. Every mark is recorded with its author. Requires a facility manager.
 */
export const verificationCheckItem = <ThrowOnError extends boolean = true>(options: Options<VerificationCheckItemData, ThrowOnError>) => (options.client ?? client).post<VerificationCheckItemResponses, VerificationCheckItemErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/check-item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Documented Value
 *
 * Says whether the values a document shows (the ISEEU and ISPEU of the economic item, the credits of the credits item) change the admission or the position of the assignee: the calculation of the residence is done again with them, and nothing is written. Only the values that differ from those that counted are weighed. Values of another item answer 422 `documented_value_not_of_item`; values all equal to those that counted answer 422 `documented_value_unchanged`. Requires a facility manager.
 */
export const verificationCheckDocumentedValue = <ThrowOnError extends boolean = true>(options: Options<VerificationCheckDocumentedValueData, ThrowOnError>) => (options.client ?? client).post<VerificationCheckDocumentedValueResponses, VerificationCheckDocumentedValueErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/check-documented-value',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Difference
 *
 * Notes that a document shows values different from those that counted, with no effect on admission or position: the item counts as checked for the compliant outcome. The effect is calculated again here: a difference against the student (an admission lost, a place further down) answers 409 `difference_has_effect`, and the item stays to check (it is a cause to exclude). `verification/check-item` with `matches` false takes the note back. A verification whose seat was lost (the offer no longer accepted) answers 409 `offer_not_accepted`. Returns the verification. Requires a facility manager.
 */
export const verificationRecordDifference = <ThrowOnError extends boolean = true>(options: Options<VerificationRecordDifferenceData, ThrowOnError>) => (options.client ?? client).post<VerificationRecordDifferenceResponses, VerificationRecordDifferenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/record-difference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Compliant
 *
 * Records the compliant outcome of a verification and returns it (FFD 2.13, step 2). It needs every item of the checklist checked and, for a student who only pre-enrolled, the student number recorded (Avviso section 3): otherwise 409 `verification_incomplete` with what is missing. A compliant verification sent again changes nothing; an excluded one answers 409 `verification_not_pending`. A verification whose seat was lost (the offer no longer accepted) answers 409 `offer_not_accepted`. The outcome is recorded with its author and time. Requires a facility manager.
 */
export const verificationMarkCompliant = <ThrowOnError extends boolean = true>(options: Options<VerificationMarkCompliantData, ThrowOnError>) => (options.client ?? client).post<VerificationMarkCompliantResponses, VerificationMarkCompliantErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/mark-compliant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Student Number
 *
 * Asks a student who only pre-enrolled for the student number: an email in the name of the residence, with the PEC of the call to reply to, and `studentNumber.requestedAt` set. Asking again sends the email again and moves the date. An offer sent from the PEC of the residence gets no email: the manager writes from there. A student who declared the number, or one already recorded, answers 409 `student_number_not_needed`; a verification with an outcome, 409 `verification_not_pending`. A verification whose seat was lost (the offer no longer accepted) answers 409 `offer_not_accepted`. Returns the verification. Requires a facility manager.
 */
export const verificationRequestStudentNumber = <ThrowOnError extends boolean = true>(options: Options<VerificationRequestStudentNumberData, ThrowOnError>) => (options.client ?? client).post<VerificationRequestStudentNumberResponses, VerificationRequestStudentNumberErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/request-student-number',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read Student Number Proof
 *
 * Reads the answer with the student number the manager uploaded: when it arrived, for the manager to confirm or correct before `record-student-number`. An `.eml` gives the time of its envelope; a PDF or an image proposes nothing. Requires a facility manager.
 */
export const verificationReadStudentNumberProof = <ThrowOnError extends boolean = true>(options: Options<VerificationReadStudentNumberProofData, ThrowOnError>) => (options.client ?? client).post<VerificationReadStudentNumberProofResponses, VerificationReadStudentNumberProofErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/read-student-number-proof',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Student Number
 *
 * Records the student number a student who only pre-enrolled sent, with the message as proof when there is one: the verification can then be compliant. A number recorded before is replaced while the verification waits. The frozen copy of the application does not change. A student who declared the number answers 409 `student_number_not_needed`; a verification with an outcome, 409 `verification_not_pending`. A verification whose seat was lost (the offer no longer accepted) answers 409 `offer_not_accepted`. Returns the verification. Requires a facility manager.
 */
export const verificationRecordStudentNumber = <ThrowOnError extends boolean = true>(options: Options<VerificationRecordStudentNumberData, ThrowOnError>) => (options.client ?? client).post<VerificationRecordStudentNumberResponses, VerificationRecordStudentNumberErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/record-student-number',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Proof Upload
 *
 * Registers the proof of a fact of the verification of a residence of the account (the document that does not match, for an exclusion) and returns where to upload it: send the raw bytes as the `upload` instruction says, then name it as `proofAssetId` in `verification/exclude`. A PDF, an image or an `.eml`, up to 25 MB; anything else answers 400. The file is private and only the account that uploaded it can use it. Requires a facility manager.
 */
export const verificationCreateProofUpload = <ThrowOnError extends boolean = true>(options: Options<VerificationCreateProofUploadData, ThrowOnError>) => (options.client ?? client).post<VerificationCreateProofUploadResponses, VerificationCreateProofUploadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/create-proof-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exclude
 *
 * Excludes an assignee who accepted, on an item that does not match, with a cause of the closed list and a proof: the verification becomes `excluded`, the accepted offer is revoked, the seat scrolls to the next one at the next calculation and the student is told by email. Returns the verification. A pending or a compliant verification can be excluded; an excluded one answers 409 `verification_excluded`. A cause of another item answers 422 `exclusion_cause_not_of_item`; a missing proof 422 `exclusion_proof_required`. A cause on the ISEEU, the ISPEU or the credits needs `documentedValue` (422 `documented_value_required`) and stands only when the value is against the student (an admission lost, a place further down): otherwise 409 `exclusion_without_effect`, and the way is `verification/record-difference`. Requires a facility manager.
 */
export const verificationExclude = <ThrowOnError extends boolean = true>(options: Options<VerificationExcludeData, ThrowOnError>) => (options.client ?? client).post<VerificationExcludeResponses, VerificationExcludeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/exclude',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Exclusion
 *
 * Corrects the exclusion of an assignee as a material error of the verification, with a proof: the exclusion is annulled, the verification waits again with the item of the exclusion to check, and at the next calculation the application is back in the ranking in its place. Whoever holds an offer keeps it; the student gets an offer only for a seat that is free, and is told by email. Returns the verification. Only an excluded verification is corrected: any other, or a renunciation or a contract not signed, answers 409 `exclusion_not_correctable`; no proof answers 422 `correction_proof_required`. Requires a facility manager.
 */
export const verificationCorrectExclusion = <ThrowOnError extends boolean = true>(options: Options<VerificationCorrectExclusionData, ThrowOnError>) => (options.client ?? client).post<VerificationCorrectExclusionResponses, VerificationCorrectExclusionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/correct-exclusion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Exclusion Proof
 *
 * Returns a short address of the proof of an exclusion of a verification of a residence of the account, or of its correction: saved, or shown in the page for a PDF or an image when `view` asks. An exclusion of another verification, or a correction not made, answers 404 `verification_not_found`. Reads a student's personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const verificationDownloadExclusionProof = <ThrowOnError extends boolean = true>(options: Options<VerificationDownloadExclusionProofData, ThrowOnError>) => (options.client ?? client).post<VerificationDownloadExclusionProofResponses, VerificationDownloadExclusionProofErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/verification/download-exclusion-proof',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Overview For Residence
 *
 * The assignees who accepted an offer of a residence of the account, with their preference of room, the quota and origin of the seat, the verification (its card, what is still to check), the room proposed and the moving in; and the beds used of each quota and site by type of room, against those of the frozen call. The assignees come a page at a time (`page`, `limit`), with `filters.state`, `filters.verificationState` and `filters.search`; the beds always count every assignee. Reads students' personal data: every successful call is recorded in the event log. Requires a facility manager.
 */
export const roomOverviewForResidence = <ThrowOnError extends boolean = true>(options: Options<RoomOverviewForResidenceData, ThrowOnError>) => (options.client ?? client).post<RoomOverviewForResidenceResponses, RoomOverviewForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/room/overview-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Propose
 *
 * Proposes the room and the site to an assignee who accepted an offer, also before the verification is compliant, and tells the student by email with the site address and how to sign the contract. Proposing again replaces the proposal and sends the email again, until the assignee moves in (409 `room_checked_in`). The proposal stays within the beds of the frozen call: those of the quota of the seat for that type of room, those of the site, and its equipped ones; a seat given with the priority of a disability needs an equipped room. Beyond a limit it answers 409 `room_limit_exceeded`, naming it. The preference of the student is not a limit. An offer not accepted answers 409 `room_offer_not_accepted`. Requires a facility manager.
 */
export const roomPropose = <ThrowOnError extends boolean = true>(options: Options<RoomProposeData, ThrowOnError>) => (options.client ?? client).post<RoomProposeResponses, RoomProposeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/room/propose',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Check In
 *
 * Confirms that an assignee moved in, on the day given. Only for an accepted offer (409 `room_offer_not_accepted`) whose verification of the documents is compliant (409 `verification_not_compliant`) and whose room is proposed (409 `room_not_proposed`); a day still to come answers 422 `check_in_date_in_future`, a day before the room was proposed 422 `check_in_date_before_proposal`. `room/overview-for-residence` gives the reason it is not possible yet. Sent again with the same day it changes nothing; with another day it answers 409 `room_checked_in`, and the day confirmed stays. Requires a facility manager.
 */
export const roomConfirmCheckIn = <ThrowOnError extends boolean = true>(options: Options<RoomConfirmCheckInData, ThrowOnError>) => (options.client ?? client).post<RoomConfirmCheckInResponses, RoomConfirmCheckInErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/room/confirm-check-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record After Acceptance Fact
 *
 * Records a fact on an accepted offer, with its cause, its day and a proof: the contract not signed within its term (only before the moving in: 409 `contract_after_check_in`) or the written renunciation of the assignee, also after the moving in. The assignment is forfeited: the offer is revoked or renounced, the seat scrolls to the next one at the next calculation, and the student is told by email. The fact is not annulled. An offer not accepted answers 409 `room_offer_not_accepted`; no proof, 422 `fact_proof_required`; a day still to come, before the acceptance or before the move-in, 422 `fact_date_out_of_range`. Requires a facility manager.
 */
export const roomRecordAfterAcceptanceFact = <ThrowOnError extends boolean = true>(options: Options<RoomRecordAfterAcceptanceFactData, ThrowOnError>) => (options.client ?? client).post<RoomRecordAfterAcceptanceFactResponses, RoomRecordAfterAcceptanceFactErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/room/record-after-acceptance-fact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get For Residence
 *
 * The DSU quota of a residence now (beds admitted to funding, threshold, seats at the DSU rate, what is missing, and where each seat of the 30% quota stands) and every change of it with its cause. The quota counts once the offers start; the history is the proof for a check of the Ministry. It names the students who hold a seat of the 30% quota: reads students' personal data, every successful call is recorded in the event log. For the facility manager of the residence and for the general admin.
 */
export const dsuQuotaGetForResidence = <ThrowOnError extends boolean = true>(options: Options<DsuQuotaGetForResidenceData, ThrowOnError>) => (options.client ?? client).post<DsuQuotaGetForResidenceResponses, DsuQuotaGetForResidenceErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/dsu-quota/get-for-residence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Report
 *
 * Generates the report of the DSU quota of a residence as a PDF: the quota now and how its threshold is calculated, each seat of the 30% quota with the protocol and the day of acceptance of the covered ones, and the whole history. It names no student. The foot carries its version (the number of changes of the quota) and the first characters of its fingerprint: the same quota gives the same fingerprint. Each export is recorded in the event log with the whole fingerprint; the file is made at each request. For the facility manager of the residence and for the general admin. Before the offers start it answers 409 `dsu_quota_not_launched`; the history is first brought up to the quota now, so the version is its content. A render that is busy answers 503 `pdf_render_unavailable`.
 */
export const dsuQuotaExportReport = <ThrowOnError extends boolean = true>(options: Options<DsuQuotaExportReportData, ThrowOnError>) => (options.client ?? client).post<DsuQuotaExportReportResponses, DsuQuotaExportReportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/dsu-quota/export-report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Ministry Answer
 *
 * Records the answer of the Ministry to the request to give the DSU seats left uncovered by the call to the 70% list (decision D85), with its day and its document, once per call: it is never changed, and a second record answers 409 `ministry_answer_recorded`. Until the answer comes, the offers of a call with uncovered DSU seats wait. A call not closed answers 409 `call_not_closed`. Returns where the call stands with the Ministry. Requires a facility manager.
 */
export const dsuQuotaRecordMinistryAnswer = <ThrowOnError extends boolean = true>(options: Options<DsuQuotaRecordMinistryAnswerData, ThrowOnError>) => (options.client ?? client).post<DsuQuotaRecordMinistryAnswerResponses, DsuQuotaRecordMinistryAnswerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/dsu-quota/record-ministry-answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlock Offers
 *
 * Releases the offers of a closed call that wait for the answer of the Ministry on its uncovered DSU seats, with the reason (decision D85): they start as with a denied answer, the seats stay uncovered. An answer recorded later still counts. A call whose offers no longer wait answers 409 `offers_already_released`; one not closed, 409 `call_not_closed`. Requires a general admin.
 */
export const dsuQuotaUnlockOffers = <ThrowOnError extends boolean = true>(options: Options<DsuQuotaUnlockOffersData, ThrowOnError>) => (options.client ?? client).post<DsuQuotaUnlockOffersResponses, DsuQuotaUnlockOffersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/dsu-quota/unlock-offers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Ministry Answer
 *
 * Returns a short address of the document of the answer of the Ministry on the DSU seats left uncovered (decision D85): saved, or shown in the page for a PDF or an image when `view` asks. A residence with no answer recorded answers 404 `ministry_answer_not_found`. For the facility manager of the residence and the general admin.
 */
export const dsuQuotaDownloadMinistryAnswer = <ThrowOnError extends boolean = true>(options: Options<DsuQuotaDownloadMinistryAnswerData, ThrowOnError>) => (options.client ?? client).post<DsuQuotaDownloadMinistryAnswerResponses, DsuQuotaDownloadMinistryAnswerErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/dsu-quota/download-ministry-answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health Check
 *
 * Returns the health check of the server
 */
export const healthCheck = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check',
    ...options
});

/**
 * Services
 *
 * Returns the health check of the server services
 */
export const healthCheckServices = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckServicesData, ThrowOnError>) => (options?.client ?? client).get<unknown, unknown, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/services',
    ...options
});

/**
 * Background
 *
 * Whether the background work runs: the queue worker and the crons each beat every 15 seconds. `ok` when they beat, `stale` (503) when one stopped beating, or never beat on a deployment that requires them, `disabled` when none runs and none is required. For monitoring; public.
 */
export const healthCheckBackground = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckBackgroundData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckBackgroundResponses, HealthCheckBackgroundErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/background',
    ...options
});
